import { Injectable } from "@nestjs/common";
import { InjectRepository } from "@nestjs/typeorm";
import {
  AllSampleDevReqResponseModel,
  BomStatusEnum,
  BuyerRefNoRequest,
  CommonResponseModel,
  FabricInfoReq,
  GlobalVariables,
  ItemTypeEnum,
  LifeCycleStatusEnum,
  MaterialStatusEnum,
  MessageParameters,
  ProductGroupReq,
  RackPositionStatusEnum,
  RequestNoReq,
  SampleDevelopmentRequest,
  SampleDevelopmentStatusEnum,
  SampleFilterRequest,
  SampleIdRequest,
  SampleProcessInfoReq,
  SampleRequestInfoModel,
  SampleSizeInfoModel,
  SamplerawmaterialStausReq,
  SourcingRequisitionReq,
  TrimInfoReq,
  UploadResponse,
  UserIdRequest,
  WhatsAppLogDto,
  buyerReq,
  buyerandM3ItemIdReq,
  lifeCycleStatusReq,
  requestNoReq,
  sampleReqIdReq,
  statusReq,
  SamUpdateReq,
  Unitreqq,
  SampleRequestId,
  TrimCodeReq,
  TrimCodereqts,
  RejectPattern,
  PurchaseOrderStatus,
  PurchaseStatusEnum,
  LocationMappedEnum,
  PoItemEnum,
} from "@project-management-system/shared-models";
import {
  IndentService,
  WhatsAppInfo,
  WhatsAppNotificationService,
} from "@project-management-system/shared-services";
import { ErrorResponse } from "packages/libs/backend-utils/src/models/global-res-object";
import { DataSource, In, Not, Repository } from "typeorm";
import { GenericTransactionManager } from "../../typeorm-transactions";
import { Buyers } from "../buyers/buyers.entity";
import { EmplyeeDetails } from "../employee-details/dto/employee-details-entity";
import { Location } from "../locations/location.entity";
import { M3TrimsEntity } from "../m3-trims/m3-trims.entity";
import { Brands } from "../master-brands/master-brands.entity";
import { OperationInventory } from "../operation-tracking/entity/operation-inventory-entity";
import { ProfitControlHead } from "../profit-control-head/profit-control-head-entity";
import { RackPositionEntity } from "../rm_locations/rack-position.entity";
import { Size } from "../sizes/sizes-entity";
import { StocksRepository } from "../stocks/repository/stocks.repository";
import { StocksEntity } from "../stocks/stocks.entity";
import { Style } from "../style/dto/style-entity";
import { AllocatedLocationRequest } from "./dto/allocated-location-req";
import { AllocationApprovalRequest } from "./dto/allocation-approval-req";
import { AllLocationRequest } from "./dto/location-req";
import { MaterialAllocationDTO } from "./dto/material-allocation-dto";
import { MaterialIssueRequest } from "./dto/material-issue.req";
import { OrderQuantityRequset } from "./dto/order-quantity-request";
import { SampleInventoryLog } from "./dto/sample-inventory-log-dto";
import { SampleOrderIdRequest } from "./dto/sample-req-id";
import { MaterialallitemsReq } from "./dto/sample-req-size-req";
import { MaterialAllocationItemsEntity } from "./entities/material-allocation-items";
import { MaterialAllocationEntity } from "./entities/material-allocation.entity";
import { SampleRequest } from "./entities/sample-dev-request.entity";
import { SampleInventoryLogEntity } from "./entities/sample-inventory-log-entity";
import { SampleReqFabricinfoEntity } from "./entities/sample-request-fabric-info-entity";
import { SampleRequestTriminfoEntity } from "./entities/sample-request-trim-info-entity";
import { SampleReqSizeEntity } from "./entities/sample-requset-size-info-entity";
import { SamplingbomEntity } from "./entities/sampling-bom-entity";
import { UploadFilesEntity } from "./entities/upload-files-entity";
import { MaterialAllocationItemsRepo } from "./repo/material-allocation-items-repo";
import { MaterialAllocationRepo } from "./repo/material-allocation-repo";
import { SampleFabricRepo } from "./repo/sample-dev-fabric-repo";
import { SampleRequestRepository } from "./repo/sample-dev-req-repo";
import { SampleSizeRepo } from "./repo/sample-dev-size-repo";
import { SampleTrimRepo } from "./repo/sample-dev-trim-repo";
import { SampleInventoryLoqRepo } from "./repo/sample-inventory-loe-repo";
import { UploadFilesRepository } from "./repo/upload-files-repository";
import { SampleRequestProcessInfoEntity } from "./entities/sample-request-process-info-entity";
import { SampleItemIdRequest } from "./dto/sample-item-id-request";
import { SampleOrderSizesRequest } from "./dto/sample-order-sizes.request";
import { StorageLocationDto } from "./dto/storage-location.dto";
import { StorageLocation } from "./entities/sample-storage-locations.entity";
import { SampleStorageLocationRepository } from "./repo/sample-storage-location-repo";
import { EmployeeDetailsRepo } from "../employee-details/dto/employee-detail-repository";
import { EmployeeBuyerMappingService } from "../employee-buyer-mapping/employee-buyer-mapping.service";
let moment = require("moment");
import * as nodemailer from "nodemailer";
import { BuyersService } from "../buyers/buyers.service";
import { Cron } from "@nestjs/schedule";
import { AppDataSource } from "../app-datasource";
import { PurchaseOrderItemsEntity } from "../purchase-order/entities/purchase-order-items-entity";
import { PurchaseOrderEntity } from "../purchase-order/entities/purchase-order-entity";
import { GrnEntity } from "../grn/entities/grn-entity";
import { GrnItemsEntity } from "../grn/entities/grn-items-entity";

@Injectable()
export class SampleRequestService {
  private transporter: nodemailer.Transporter;

  constructor(
    private sampleRepo: SampleRequestRepository,
    private readonly dataSource: DataSource,
    // private sampleAdapter: SampleDevAdapter,
    private sizerepo: SampleSizeRepo,
    private fabricRepo: SampleFabricRepo,
    private sampletrimrepo: SampleTrimRepo,
    @InjectRepository(SamplingbomEntity)
    private bomRepo: Repository<SamplingbomEntity>,
    private logRepo: SampleInventoryLoqRepo,
    private indentService: IndentService,
    private matAllRepo: MaterialAllocationRepo,
    private matAllitemRepo: MaterialAllocationItemsRepo,
    private stockrepo: StocksRepository,
    private wpService: WhatsAppNotificationService,
    private uploadFilesRepository: UploadFilesRepository,
    private sampleStorageLocationRepository: SampleStorageLocationRepository,
    private employeeDetailsRepo: EmployeeDetailsRepo,
    private employeeBuyerMappingService: EmployeeBuyerMappingService,
    private buyerService: BuyersService,
    @InjectRepository(PurchaseOrderItemsEntity)
    private poItemRepo: Repository<PurchaseOrderItemsEntity>,
    @InjectRepository(PurchaseOrderEntity)
    private poRepo: Repository<PurchaseOrderEntity>,
    @InjectRepository(GrnEntity)
    private grnRepo: Repository<GrnEntity>,
    @InjectRepository(GrnItemsEntity)
    private grnItemRepo: Repository<GrnItemsEntity>
  ) {
    this.transporter = nodemailer.createTransport({
      service: "gmail",
      auth: {
        user: "helpdesk@schemaxtech.com",
        pass: "jend gpnz htps asjn",
      },
    });
  }

  async getAllSampleDevData(
    request?: SampleFilterRequest
  ): Promise<AllSampleDevReqResponseModel> {
    try {
      const details = await this.sampleRepo.getAllSampleDevData(request);
      // console.log(details)
      // console.log('^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^66')
      if (details.length > 0) {
        // console.log("testtttttttt")
        for (const rec of details) {
          rec.fabric = await this.sampleRepo.sampleFabric(
            rec.sample_request_id
          );
          rec.trimData = await this.sampleRepo.sampleTrimData(
            rec.sample_request_id
          );
        }
        // console.log(details);

        return new AllSampleDevReqResponseModel(
          true,
          32465,
          "All Sample Requests retrieved successfully",
          details
        );
      } else {
        return new AllSampleDevReqResponseModel(
          false,
          1002,
          "No data found",
          []
        );
      }
    } catch (err) {
      throw err;
    }
  }

  async getAllSampleData(): Promise<AllSampleDevReqResponseModel> {
    try {
      const details = await this.sampleRepo.find({
        relations: ["sampleReqFabricInfo", "sampleTrimInfo"],
      });
      if (details.length > 0) {
        return new AllSampleDevReqResponseModel(
          true,
          0,
          "All Sample Requests retrieved successfully",
          details
        );
      } else {
        return new AllSampleDevReqResponseModel(false, 1, "No data found", []);
      }
    } catch (err) {
      throw err;
    }
  }

  async getAllSampleReqNo(): Promise<CommonResponseModel> {
    try {
      const details = await this.sampleRepo.find({
        select: ["requestNo"],
        order: { requestNo: "ASC" },
      });
      if (details.length > 0) {
        let request = [];
        for (const code of details) {
          request.push(new RequestNoReq());
        }
        return new CommonResponseModel(true, 1, "data retrieved", details);
      } else {
        return new CommonResponseModel(false, 0, "data not found");
      }
    } catch (err) {
      throw err;
    }
  }

  async getPch(): Promise<CommonResponseModel> {
    const details = await this.sampleRepo.getPch();
    if (details.length > 0) {
      return new CommonResponseModel(true, 1, "data retrieved", details);
    } else {
      return new CommonResponseModel(false, 0, "data not found");
    }
  }

  async getStyle(): Promise<CommonResponseModel> {
    const details = await this.sampleRepo.getStyle();
    if (details.length > 0) {
      return new CommonResponseModel(true, 1, "data retrieved", details);
    } else {
      return new CommonResponseModel(false, 0, "data not found");
    }
  }

  async getAllSampleReqDropDown(): Promise<CommonResponseModel> {
    const details = await this.sampleRepo.getAllSampleReqDropDown();
    if (details.length > 0) {
      return new CommonResponseModel(true, 1, "data retrieved", details);
    } else {
      return new CommonResponseModel(false, 0, "data not found");
    }
  }

  async getIssuedSampleRequests(
    req?: BuyerRefNoRequest
  ): Promise<CommonResponseModel> {
    if (req?.buyerRefNo) {
      const buyerdata = `select buyer_id from buyers where external_ref_number = '${req.buyerRefNo}'`;
      const res = await this.dataSource.query(buyerdata);
      req.buyerId = res[0].buyer_id;
    }
    const details = await this.sampleRepo.getIssuedSampleRequests(req);
    if (details.length > 0) {
      return new CommonResponseModel(true, 1, "data retrieved", details);
    } else {
      return new CommonResponseModel(false, 0, "data not found");
    }
  }

  async cancelSampleReqById(
    request: SampleFilterRequest
  ): Promise<AllSampleDevReqResponseModel> {
    try {
      const sampleReq = await this.sampleRepo.findOne({
        where: { SampleRequestId: request.sampleId },
      });
      if (sampleReq) {
        const updateResult = await this.sampleRepo.update(
          { SampleRequestId: request.sampleId },
          { status: SampleDevelopmentStatusEnum.CANCELLED }
        );
        if (updateResult) {
          return new AllSampleDevReqResponseModel(
            true,
            1,
            "Sample Request cancelled successfully",
            undefined
          );
        }
      } else {
        return new AllSampleDevReqResponseModel(
          false,
          0,
          "No Sample Request found",
          []
        );
      }
    } catch (err) {
      throw err;
    }
  }

  async getAllPCH(): Promise<CommonResponseModel> {
    const details = await this.sampleRepo.getAllPCH();
    if (details.length > 0) {
      return new CommonResponseModel(true, 1, "data retrieved", details);
    } else {
      return new CommonResponseModel(false, 0, "data not found");
    }
  }

  // async createSampleDevelopmentRequest(req: SampleDevelopmentRequest): Promise<AllSampleDevReqResponseModel> {
  //   const manager = new GenericTransactionManager(this.dataSource)
  //   // console.log(req)
  //   // console.log(req.sizeData[0].sizeInfo,'#####')
  //   let save
  //   let saveBomDetails
  //   try {
  //     await manager.startTransaction();
  //     // const sampleId = await this.sampleRepo.getsampleId()
  //     // const maxId = sampleId.id
  //     const sampleReqEntity = new SampleRequest();
  //     // const locationEntity = new Location()
  //     // locationEntity.locationId = req.locationId
  //     sampleReqEntity.locationId = req.locationId
  //     sampleReqEntity.expectedDeliveryDate = req.expectedDeliveryDate
  //     sampleReqEntity.requestNo = "SAM" + "/" + "23-24" + "/" + "00000" + Number(Number(1) + 1);
  //     const profitHead = new ProfitControlHead()
  //     profitHead.profitControlHeadId = req.pchId
  //     sampleReqEntity.pch = profitHead
  //     sampleReqEntity.user = req.user
  //     const buyer = new Buyers()
  //     buyer.buyerId = req.buyerId
  //     sampleReqEntity.buyer = buyer
  //     // const samType = new SampleTypes()
  //     // samType.sampleTypeId = req.sampleTypeId
  //     // sampleReqEntity.sampleType = samType
  //     // const samSubType = new SampleSubTypes()
  //     // samSubType.sampleSubTypeId = req.sampleSubTypeId
  //     // sampleReqEntity.sampleSubType = samSubType
  //     const styleEntity = new Style()
  //     styleEntity.styleId = req.styleId
  //     sampleReqEntity.style = styleEntity
  //     sampleReqEntity.description = req.description
  //     const brand = new Brands()
  //     brand.brandId = req.brandId
  //     sampleReqEntity.brand = brand
  //     sampleReqEntity.costRef = req.costRef
  //     // sampleReqEntity.m3StyleNo = req.m3Style
  //     sampleReqEntity.contact = req.contact
  //     sampleReqEntity.extension = req.extension
  //     sampleReqEntity.samValue = req.samValue
  //     const dmm = new EmplyeeDetails()
  //     dmm.employeeId = req.dmmId
  //     sampleReqEntity.dmm = dmm
  //     const employee = new EmplyeeDetails()
  //     employee.employeeId = req.technicianId
  //     sampleReqEntity.technician = employee
  //     sampleReqEntity.product = req.product
  //     // sampleReqEntity.type = req.type
  //     sampleReqEntity.conversion = req.conversion
  //     sampleReqEntity.madeIn = req.madeIn
  //     sampleReqEntity.remarks = req.remarks
  //     sampleReqEntity.status = req.status
  //     sampleReqEntity.category = req.category
  //     // let sampleSizeInfo = []
  //     // let sampleFabricInfo = []
  //     // let sampleTrimInfo = []
  //     // let sampleProcessInfo = []
  //     // for (const size of req.sizeData) {
  //     //   for (const sizedetails of size.sizeInfo) {
  //     //     const sizeEntity = new SampleReqSizeEntity()
  //     //     sizeEntity.colourId = size.colorId
  //     //     sizeEntity.sizeId = sizedetails.sizeId
  //     //     sizeEntity.quantity = sizedetails.quantity
  //     //     sampleSizeInfo.push(sizeEntity)
  //     //   }
  //     // }
  //     // sampleReqEntity.sampleReqSizeInfo = sampleSizeInfo;
  //     // let indentFabInfo : FabricInfoReq[] = [];
  //     // for (let fabricObj of req.fabricInfo) {
  //     //   const fabricEntity = new SampleReqFabricinfoEntity()
  //     //   fabricEntity.fabricCode = fabricObj.fabricCode
  //     //   fabricEntity.colourId = fabricObj.colourId
  //     //   fabricEntity.consumption = fabricObj.consumption
  //     //   fabricEntity.uomId = fabricObj.uomId
  //     //   fabricEntity.remarks = fabricObj.remarks
  //     //   fabricEntity.totalRequirement = fabricObj.totalRequirement
  //     //   fabricEntity.wastage = fabricObj.wastage
  //     //   sampleFabricInfo.push(fabricEntity)
  //     //   const fabricInfoReq = new FabricInfoReq(fabricObj.fabricCode,fabricObj.colourId,fabricObj.consumption,fabricObj.uomId,fabricObj.remarks)
  //     //   indentFabInfo.push(fabricInfoReq);
  //     // }
  //     // sampleReqEntity.sampleReqFabricInfo = sampleFabricInfo;
  //     // let indentTrimInfo : TrimInfoReq[] = [];
  //     // for (const trimObj of req.trimInfo) {
  //     //   let m3Data : M3TrimsEntity
  //     //   if(trimObj.uomStatus){
  //     //     m3Data = await manager.getRepository(M3TrimsEntity).findOne({where:{m3TrimId:trimObj.trimCode}});
  //     //   }
  //     //   const trimEntity = new SampleRequestTriminfoEntity()
  //     //   trimEntity.trimCode = trimObj.trimCode
  //     //   trimEntity.uomId = m3Data?.uomId != null ? m3Data?.uomId:null;
  //     //   trimEntity.consumption = trimObj.consumption
  //     //   trimEntity.trimType = trimObj.trimType
  //     //   trimEntity.remarks = trimObj.remarks
  //     //   trimEntity.totalRequirement = trimObj.totalRequirement
  //     //   trimEntity.wastage = trimObj.wastage
  //     //   sampleTrimInfo.push(trimEntity)
  //     //   const trimInfoReq = new TrimInfoReq(trimObj.trimType,trimObj.trimCode,trimObj.consumption,trimObj.uomId,trimObj.remarks)
  //     //   indentTrimInfo.push(trimInfoReq);

  //     // }
  //     // sampleReqEntity.sampleTrimInfo = sampleTrimInfo
  //     // for (const processObj of req.processInfo) {
  //     //   const processEntity = new SampleRequestProcessInfoEntity()
  //     //   processEntity.process = processObj.process
  //     //   processEntity.description = processObj.description
  //     //   sampleProcessInfo.push(processEntity)
  //     // }
  //     // sampleReqEntity.sampleProcessInfo = sampleProcessInfo

  //     console.log("***********sampleReqEntity*************")
  //     console.log(sampleReqEntity)
  //     console.log("***********sampleReqEntity*************")
  //     console.log(await manager.getRepository(SampleRequest).save(sampleReqEntity))

  //     // save = await manager.getRepository(SampleRequest).save(sampleReqEntity);
  //     console.log("$############################################################");
  //     console.log(save);

  //     // save = await this.sampleRepo.save(sampleReqEntity)
  //     // if (save)
  //     // {
  //     //   let fabFlag = new Set<boolean>()
  //     //   if (req.fabricInfo) {
  //     //     let fabricAllocation;
  //     //     for (const fabricData of req.fabricInfo) {
  //     //       const quantityWithWastage = Number(fabricData.consumption) + Number((2 / 100) * fabricData.consumption)
  //     //       const bomEntity = new SamplingbomEntity()
  //     //       bomEntity.sampleRequestId = save.SampleRequestId
  //     //       bomEntity.colourId = fabricData.colourId
  //     //       bomEntity.m3ItemId=fabricData.fabricCode
  //     //       bomEntity.itemType='Fabric';
  //     //       bomEntity.requiredQuantity = fabricData.totalRequirement
  //     //       bomEntity.sampleItemId = save.sampleReqFabricInfo.find((e) => e.fabricCode === fabricData.fabricCode && e. colourId === fabricData.colourId).fabricInfoId
  //     //       saveBomDetails = await manager.getRepository(SamplingbomEntity).save(bomEntity)
  //     //       // saveBomDetails = await this.bomRepo.save(bomEntity)

  //     //       console.log("######################################################################")
  //     //       console.log(fabricData.allocatedStock);
  //     //       console.log(fabricData.allocatedStock.find((e)=>e.checkedStatus === 1));

  //     //       if(fabricData.allocatedStock.find((e)=>e.checkedStatus === 1) != undefined)
  //     //       {
  //     //         let stockArray : any[] = [];
  //     //         stockArray.push(fabricData.allocatedStock.find((e)=>e.checkedStatus === 1 && e.issuedQty > 0));
  //     //         console.log(stockArray);
  //     //         console.log("if")
  //     //         console.log(req)
  //     //         console.log(req.buyerId)

  //     //         let totalAllocated = 0
  //     //         let item:MaterialAllocationItemsEntity[] = []
  //     //         for (const stock of stockArray) {
  //     //           console.log("7777")
  //     //             totalAllocated = Number(totalAllocated) + Number(stock.issuedQty);
  //     //             let itemData = new MaterialAllocationItemsEntity();
  //     //             itemData.locationId = stock.locationId;
  //     //             itemData.quantity = stock.quantity;
  //     //             itemData.stockId = stock.stockId;
  //     //             itemData.allocateQuantity = stock.issuedQty;
  //     //             item.push(itemData);
  //     //             let stockUpdate = await manager.getRepository(StocksEntity).update({id:stock.stockId},{allocateQuanty: () => `allocatd_quantity +  ${stock.issuedQty}`});
  //     //             if(stockUpdate.affected === 0){
  //     //               await manager.releaseTransaction();
  //     //             }
  //     //         }
  //     //         let materialAllocation = new MaterialAllocationEntity();

  //     //         materialAllocation.buyerId = req.buyerId!= undefined?req.buyerId:0;
  //     //         materialAllocation.itemType = ItemTypeEnum.FABRIC
  //     //         materialAllocation.m3ItemId = fabricData.fabricCode
  //     //         materialAllocation.totalIssueQty = totalAllocated
  //     //         materialAllocation.sampleOrderId = save.SampleRequestId;
  //     //         // materialAllocation.samplingBomId = saveBomDetails.samplingBomId;
  //     //         materialAllocation.sampleItemId = save.sampleReqFabricInfo.find((e) => e.fabricCode === fabricData.fabricCode && e. colourId === fabricData.colourId).fabricInfoId;
  //     //         materialAllocation.materialAllocationinfo = item;
  //     //         console.log(materialAllocation);
  //     //         console.log(materialAllocation)
  //     //         fabricAllocation = await manager.getRepository(MaterialAllocationEntity).save(materialAllocation);
  //     //         // fabricAllocation = await this.creatematerialAlloction(materialAllocation);

  //     //         console.log(fabricAllocation);
  //     //         // fabricAllocation = await manager.getRepository(MaterialAllocationEntity).save(allocationEntity)
  //     //         if(!fabricAllocation){
  //     //           fabFlag.add(false);
  //     //           await manager.releaseTransaction();
  //     //           return new AllSampleDevReqResponseModel(false, 0, 'Material Allocation Failed', [])
  //     //         }
  //     //         else{
  //     //           console.log("&&&&&&&&&&")
  //     //           console.log(fabricData.totalRequirement)
  //     //           console.log(totalAllocated);
  //     //           let fabBomStatus = BomStatusEnum.OPEN;
  //     //           if(Number(fabricData.totalRequirement) === Number(totalAllocated)){
  //     //             fabBomStatus = BomStatusEnum.ALLOCATED
  //     //             // fabFlag.add(true)
  //     //           }
  //     //           // else{
  //     //           //   fabFlag.add(false)
  //     //           // }
  //     //           let updateSampleFabricInfo = await manager.getRepository(SamplingbomEntity).update({samplingBomId:saveBomDetails.samplingBomId},{status:fabBomStatus,receivedQuantity : () => `received_quantity + ${totalAllocated}`})
  //     //           if(updateSampleFabricInfo.affected === 0){
  //     //             fabFlag.add(false)
  //     //             await manager.releaseTransaction();
  //     //             return new AllSampleDevReqResponseModel(false, 0, 'Material Allocation Failed', [])
  //     //           }
  //     //           else{
  //     //             fabFlag.add(true)
  //     //           }
  //     //         }
  //     //       }
  //     //       else{
  //     //         console.log("else")
  //     //       }

  //     //     }
  //     //   }
  //     //   let trimFlag = new Set<boolean>()
  //     //   if (req.trimInfo) {
  //     //     let trimAllocation;
  //     //     for (const trimData of req.trimInfo) {
  //     //       const bomEntity = new SamplingbomEntity()
  //     //       bomEntity.sampleRequestId = save.SampleRequestId
  //     //       bomEntity.itemType=trimData.trimType
  //     //       bomEntity.m3ItemId=trimData.trimCode
  //     //       bomEntity.colourId = trimData.colourId
  //     //       bomEntity.requiredQuantity = trimData.totalRequirement
  //     //       bomEntity.sampleItemId = save.sampleTrimInfo.find((e) => e.trimCode === trimData.trimCode).trimInfoId
  //     //       saveBomDetails = await manager.getRepository(SamplingbomEntity).save(bomEntity);
  //     //       // saveBomDetails = await this.bomRepo.save(bomEntity)

  //     //       if(trimData.allocatedStock.find((e)=>e.checkedStatus === 1) != undefined)
  //     //       {
  //     //         let stockArray : any[] = []
  //     //         stockArray.push(trimData.allocatedStock.find((e)=>e.checkedStatus === 1 && e.issuedQty > 0))
  //     //         console.log(stockArray);
  //     //         let totalAllocated = 0
  //     //         let item:MaterialAllocationItemsEntity[] = []
  //     //         for (const stock of stockArray) {
  //     //           totalAllocated = Number(totalAllocated) + Number(stock.issuedQty);
  //     //           let itemData = new MaterialAllocationItemsEntity();
  //     //           itemData.locationId = stock.locationId;
  //     //           itemData.quantity = stock.quantity;
  //     //           itemData.stockId = stock.stockId;
  //     //           itemData.allocateQuantity = stock.issuedQty;
  //     //           item.push(itemData);
  //     //           let stockUpdate = await manager.getRepository(StocksEntity).update({id:stock.stockId},{allocateQuanty: () => `allocatd_quantity +  ${stock.issuedQty}`});
  //     //             if(stockUpdate.affected === 0){
  //     //               console.log("1111111111111111111111111111111111111111111111111111111111111");
  //     //               trimFlag.add(false);
  //     //               await manager.releaseTransaction();
  //     //             }
  //     //         }
  //     //         let materialAllocation = new MaterialAllocationEntity();

  //     //         materialAllocation.buyerId = req.buyerId
  //     //         materialAllocation.itemType = trimData.trimType
  //     //         materialAllocation.m3ItemId = trimData.trimCode
  //     //         materialAllocation.totalIssueQty = totalAllocated
  //     //         materialAllocation.sampleOrderId = save.SampleRequestId;
  //     //         // materialAllocation.samplingBomId = saveBomDetails.samplingBomId;
  //     //         materialAllocation.sampleItemId = save.sampleTrimInfo.find((e) => e.trimCode === trimData.trimCode).trimInfoId;
  //     //         materialAllocation.materialAllocationinfo = item;
  //     //         console.log(materialAllocation);
  //     //         // trimAllocation = await this.creatematerialAlloction(materialAllocation);
  //     //         trimAllocation = await manager.getRepository(MaterialAllocationEntity).save(materialAllocation);

  //     //         console.log("$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$");
  //     //         console.log(trimAllocation);

  //     //         if(!trimAllocation){
  //     //           console.log("222222222222222222222222222222222222222222222222222222222222");

  //     //           trimFlag.add(false)
  //     //           await manager.releaseTransaction();
  //     //           return new AllSampleDevReqResponseModel(false, 0, 'Material Allocation Failed', [])
  //     //         }
  //     //         // else{
  //     //         //   trimFlag.add(true)
  //     //         // }
  //     //         else{
  //     //           let trimBomStatus = BomStatusEnum.OPEN;
  //     //           if(Number(trimData.totalRequirement) === Number(totalAllocated)){
  //     //             trimBomStatus = BomStatusEnum.ALLOCATED
  //     //             // trimFlag.add(true);
  //     //           }
  //     //           console.log(saveBomDetails)
  //     //           let updateSampleFabricInfo = await manager.getRepository(SamplingbomEntity).update({samplingBomId:saveBomDetails.samplingBomId},{status:trimBomStatus,receivedQuantity : () => `received_quantity + ${totalAllocated}`})
  //     //           console.log("updateSampleFabricInfo")
  //     //           console.log(updateSampleFabricInfo)

  //     //           if(updateSampleFabricInfo.affected === 0){
  //     //             console.log("333333333333333333333333333333333333333333333333333333333333333333333");
  //     //             trimFlag.add(false);
  //     //             await manager.releaseTransaction();
  //     //             return new AllSampleDevReqResponseModel(false, 0, 'Material Allocation Failed', [])
  //     //           }
  //     //           else{
  //     //             trimFlag.add(true);
  //     //           }
  //     //         }
  //     //       }
  //     //     }
  //     //   }
  //     //   console.log(fabFlag.has(true) +"-"+ trimFlag.has(true))
  //     //   console.log(fabFlag.has(false) +"-"+ trimFlag.has(false))

  //     //   if(!fabFlag.has(false) || !trimFlag.has(false)){
  //     //     let updateSampleRequestStatus = await manager.getRepository(SampleRequest).update({SampleRequestId:save.SampleRequestId},{lifeCycleStatus:LifeCycleStatusEnum.READY_FOR_PRODUCTION})
  //     //     console.log(updateSampleRequestStatus)
  //     //       if(updateSampleRequestStatus.affected === 0){
  //     //         await manager.releaseTransaction();
  //     //         return new AllSampleDevReqResponseModel(false, 0, 'Material Allocation Failed', [])
  //     //       }
  //     //   }
  //     // }
  //     // else{
  //     //   await manager.releaseTransaction();
  //     //   return new AllSampleDevReqResponseModel(false, 0, 'SampleDevelopmentRequest creation Failed', [])
  //     // }
  //     // if (save && saveBomDetails) {
  //     //   await manager.completeTransaction();
  //     //   console.log("%%%%%%%%%%%%%%%%%%%%%%%%%%%%%");
  //     //   console.log(save);

  //     //   for(const res of req.fabricInfo){
  //     //     save.sampleReqFabricInfo.find((rec) => rec.fabricCode === res.fabricCode && rec.colourId == res.colourId)["fabricUpload"] = res.fabricUpload;

  //     //   }

  //     //   const req1 = new SourcingRequisitionReq(req.styleId,new Date(),"",new Date(),indentFabInfo,indentTrimInfo,save.SampleRequestId);
  //     //   // const raiseIndent = await this.indentService.createItems(req1);
  //     //   // if(raiseIndent.status){
  //     //     return new AllSampleDevReqResponseModel(true, 1, 'SampleDevelopmentRequest created successfully', [save])
  //     //   // }
  //     //   // else {
  //     //   //   return new AllSampleDevReqResponseModel(false, 0, 'SampleDevelopmentRequest creation Failed', [])
  //     //   // }
  //     // }
  //     // else {
  //       return new AllSampleDevReqResponseModel(false, 0, 'SampleDevelopmentRequest creation Failed', [])
  //     // }
  //   }
  //   catch (err) {
  //     console.log(err);
  //     await manager.releaseTransaction();
  //     throw err
  //   }

  // }
  async createSampleDevelopmentRequest(
    req: SampleDevelopmentRequest
  ): Promise<AllSampleDevReqResponseModel> {
    const manager = new GenericTransactionManager(this.dataSource);
    // console.log(req)
    // console.log(req.subType)

    // console.log(req.sizeData[0].sizeInfo,'#####')
    let save;
    let saveBomDetails;
    try {
      await manager.startTransaction();
      const sampleId = await this.sampleRepo.getsampleId();
      const maxId = sampleId.id;
      const sampleReqEntity = new SampleRequest();
      // const locationEntity = new Location()
      // locationEntity.locationId = req.locationId
      sampleReqEntity.locationId = req.locationId;
      sampleReqEntity.expectedDeliveryDate = req.expectedDeliveryDate;
      sampleReqEntity.requestNo =
        "SAM" + "/" + "23-24" + "/" + "00000" + Number(Number(maxId) + 1);
      const profitHead = new ProfitControlHead();
      profitHead.profitControlHeadId = req.pchId;
      sampleReqEntity.pch = profitHead;
      sampleReqEntity.user = req.user;
      const buyer = new Buyers();
      buyer.buyerId = req.buyerId;
      sampleReqEntity.buyer = buyer;
      // const samType = new SampleTypes()
      sampleReqEntity.sampleTypeId = req.type;
      // sampleReqEntity.sampleType = samType
      // const samSubType = new SampleSubTypes()
      sampleReqEntity.sampleSubTypeId = req.subType;
      // sampleReqEntity.sampleSubType = samSubType
      const styleEntity = new Style();
      styleEntity.styleId = req.styleId;
      sampleReqEntity.style = styleEntity;
      sampleReqEntity.description = req.description;
      sampleReqEntity.plantId = req.plantId;
      sampleReqEntity.priority = req.priority;
      sampleReqEntity.shrinkage = req.shrinkage;
      const brand = new Brands();
      brand.brandId = req.brandId;
      sampleReqEntity.brand = brand;
      sampleReqEntity.costRef = req.costRef;
      // sampleReqEntity.m3StyleNo = req.m3Style
      sampleReqEntity.contact = req.contact;
      sampleReqEntity.extension = req.extension;
      sampleReqEntity.samValue = req.samValue;
      sampleReqEntity.exFactoryDate = req.exFactoryDate;
      sampleReqEntity.exStitchDate = req.exStitchDate;
      sampleReqEntity.reasonForRework = req.reasonForRework;
      sampleReqEntity.referenceOrderId = req.referenceOrderId;
      const dmm = new EmplyeeDetails();
      dmm.employeeId = req.dmmId;
      sampleReqEntity.dmm = dmm;
      // const employee = new EmplyeeDetails()
      // employee.employeeId = req.technicianId
      // sampleReqEntity.technician = employee
      sampleReqEntity.product = req.product;
      // sampleReqEntity.type = req.type === '' || undefined?null:req.type
      // sampleReqEntity.conversion = req.conversion
      // sampleReqEntity.madeIn = req.madeIn
      sampleReqEntity.remarks = req.remarks;
      sampleReqEntity.status = req.status;
      sampleReqEntity.category = req.category;
      sampleReqEntity.locationsId = req.locationsId;
      sampleReqEntity.patternId = req.patternId;
      let sampleSizeInfo = [];
      let sampleFabricInfo = [];
      let sampleTrimInfo = [];
      let sampleProcessInfo = [];
      for (const size of req.sizeData) {
        for (const sizedetails of size.sizeInfo) {
          const sizeEntity = new SampleReqSizeEntity();
          sizeEntity.colourId = size.colorId;
          sizeEntity.sizeId = sizedetails.sizeId;
          sizeEntity.quantity = sizedetails.quantity;
          sampleSizeInfo.push(sizeEntity);
        }
      }
      sampleReqEntity.sampleReqSizeInfo = sampleSizeInfo;
      let indentProcessInfo: SampleProcessInfoReq[] = [];
      for (let processObj of req.processInfo) {
        const processEntity = new SampleRequestProcessInfoEntity();
        processEntity.operation = processObj.operation;
        processEntity.sequence = processObj.sequence;
        processEntity.remarks = processObj.remarks;
        sampleProcessInfo.push(processEntity);
        const processInfoReq = new SampleProcessInfoReq(
          processEntity.operation,
          processEntity.sequence,
          processEntity.remarks
        );
        indentProcessInfo.push(processInfoReq);
      }
      sampleReqEntity.sampleProcessInfo = sampleProcessInfo;
      let indentFabInfo: FabricInfoReq[] = [];
      for (let fabricObj of req.fabricInfo) {
        const fabricEntity = new SampleReqFabricinfoEntity();
        fabricEntity.fabricCode = fabricObj.fabricCode;
        fabricEntity.colourId = fabricObj.colourId;
        fabricEntity.consumption = fabricObj.consumption;
        fabricEntity.uomId = fabricObj.uomId;
        fabricEntity.remarks = fabricObj.remarks;
        fabricEntity.totalRequirement = fabricObj.totalRequirement;
        fabricEntity.wastage = fabricObj.wastage;
        fabricEntity.fabColourId = fabricObj.fabricColorId;
        sampleFabricInfo.push(fabricEntity);
        const fabricInfoReq = new FabricInfoReq(
          fabricObj.fabricCode,
          fabricObj.colourId,
          fabricObj.consumption,
          fabricObj.uomId,
          fabricObj.remarks
        );
        indentFabInfo.push(fabricInfoReq);
      }
      sampleReqEntity.sampleReqFabricInfo = sampleFabricInfo;
      let indentTrimInfo: TrimInfoReq[] = [];
      for (const trimObj of req.trimInfo) {
        let m3Data: M3TrimsEntity;
        if (trimObj.uomStatus) {
          m3Data = await manager
            .getRepository(M3TrimsEntity)
            .findOne({ where: { m3TrimId: trimObj.trimCode } });
        }
        const trimEntity = new SampleRequestTriminfoEntity();
        trimEntity.trimCode = trimObj.trimCode;
        trimEntity.uomId = m3Data?.uomId != null ? m3Data?.uomId : null;
        trimEntity.consumption = trimObj.consumption;
        trimEntity.trimType = trimObj.trimType;
        trimEntity.remarks = trimObj.remarks;
        trimEntity.totalRequirement = trimObj.totalRequirement;
        trimEntity.wastage = trimObj.wastage;
        trimEntity.colourId = trimObj.colourId;
        trimEntity.trimColourId = trimObj.trimColorId;

        sampleTrimInfo.push(trimEntity);
        const trimInfoReq = new TrimInfoReq(
          trimObj.trimType,
          trimObj.trimCode,
          trimObj.consumption,
          trimObj.uomId,
          trimObj.remarks
        );
        indentTrimInfo.push(trimInfoReq);
      }
      sampleReqEntity.sampleTrimInfo = sampleTrimInfo;
      // for (const processObj of req.processInfo) {
      //   const processEntity = new SampleRequestProcessInfoEntity()
      //   processEntity.process = processObj.process
      //   processEntity.description = processObj.description
      //   sampleProcessInfo.push(processEntity)
      // }
      // sampleReqEntity.sampleProcessInfo = sampleProcessInfo

      save = await manager.getRepository(SampleRequest).save(sampleReqEntity);
      // console.log("$############################################################");
      // console.log(save);

      // save = await this.sampleRepo.save(sampleReqEntity)
      if (save) {
        let fabFlag = new Set<boolean>();
        if (req.fabricInfo) {
          let fabricAllocation;
          for (const fabricData of req.fabricInfo) {
            const quantityWithWastage =
              Number(fabricData.consumption) +
              Number((2 / 100) * fabricData.consumption);
            const bomEntity = new SamplingbomEntity();
            bomEntity.sampleRequestId = save.SampleRequestId;
            bomEntity.colourId = fabricData.colourId;
            bomEntity.m3ItemId = fabricData.fabricCode;
            bomEntity.itemType = "Fabric";
            bomEntity.requiredQuantity = fabricData.totalRequirement;
            bomEntity.sampleItemId = save.sampleReqFabricInfo.find(
              (e) =>
                e.fabricCode === fabricData.fabricCode &&
                e.colourId === fabricData.colourId
            ).fabricInfoId;
            saveBomDetails = await manager
              .getRepository(SamplingbomEntity)
              .save(bomEntity);
            // saveBomDetails = await this.bomRepo.save(bomEntity)

            // console.log("######################################################################")
            // console.log(fabricData.allocatedStock);
            // console.log(fabricData.allocatedStock.find((e) => e.checkedStatus === 1));

            if (
              fabricData.allocatedStock.find((e) => e.checkedStatus === 1) !=
              undefined
            ) {
              let stockArray: any[] = [];
              stockArray.push(
                fabricData.allocatedStock.filter(
                  (e) => e.checkedStatus === 1 && e.issuedQty > 0
                )
              );
              // console.log(stockArray);
              // console.log("if")
              // console.log(req)
              // console.log(req.buyerId)

              let totalAllocated = 0;
              let item: MaterialAllocationItemsEntity[] = [];
              for (const stock of stockArray) {
                for (const stk of stock) {
                  // console.log(stk);
                  // console.log("7777")
                  // console.log(stock);

                  totalAllocated =
                    Number(totalAllocated) + Number(stk.issuedQty);
                  let itemData = new MaterialAllocationItemsEntity();
                  itemData.locationId = stk.locationId;
                  itemData.quantity = stk.quantity;
                  itemData.stockId = stk.stockId;
                  itemData.allocateQuantity = stk.issuedQty;
                  itemData.plantId = req.plantId;
                  item.push(itemData);
                  let stockUpdate = await manager
                    .getRepository(StocksEntity)
                    .update(
                      { id: stk.stockId },
                      {
                        allocateQuanty: () =>
                          `allocatd_quantity +  ${stk.issuedQty}`,
                      }
                    );
                  if (stockUpdate.affected === 0) {
                    await manager.releaseTransaction();
                  }
                }
              }
              let materialAllocation = new MaterialAllocationEntity();

              materialAllocation.buyerId =
                req.buyerId != undefined ? req.buyerId : 0;
              materialAllocation.itemType = ItemTypeEnum.FABRIC;
              materialAllocation.m3ItemId = fabricData.fabricCode;
              materialAllocation.totalIssueQty = totalAllocated;
              materialAllocation.sampleOrderId = save.SampleRequestId;
              materialAllocation.plantId = req.plantId;
              // materialAllocation.samplingBomId = saveBomDetails.samplingBomId;
              materialAllocation.sampleItemId = save.sampleReqFabricInfo.find(
                (e) =>
                  e.fabricCode === fabricData.fabricCode &&
                  e.colourId === fabricData.colourId
              ).fabricInfoId;
              materialAllocation.materialAllocationinfo = item;
              // console.log(materialAllocation);
              // console.log(materialAllocation)
              fabricAllocation = await manager
                .getRepository(MaterialAllocationEntity)
                .save(materialAllocation);
              // fabricAllocation = await this.creatematerialAlloction(materialAllocation);

              // console.log(fabricAllocation);
              // fabricAllocation = await manager.getRepository(MaterialAllocationEntity).save(allocationEntity)
              if (!fabricAllocation) {
                fabFlag.add(false);
                await manager.releaseTransaction();
                return new AllSampleDevReqResponseModel(
                  false,
                  0,
                  "Material Allocation Failed",
                  []
                );
              } else {
                // console.log("&&&&&&&&&&")
                // console.log(fabricData.totalRequirement)
                // console.log(totalAllocated) bn nnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnn                                                                                                                                                         b;
                let fabBomStatus = BomStatusEnum.OPEN;
                if (
                  Number(fabricData.totalRequirement) === Number(totalAllocated)
                ) {
                  fabBomStatus = BomStatusEnum.ALLOCATED;
                  // fabFlag.add(true)
                }
                // else{
                //   fabFlag.add(false)
                // }
                let updateSampleFabricInfo = await manager
                  .getRepository(SamplingbomEntity)
                  .update(
                    { samplingBomId: saveBomDetails.samplingBomId },
                    {
                      status: fabBomStatus,
                      receivedQuantity: () =>
                        `received_quantity + ${totalAllocated}`,
                    }
                  );
                if (updateSampleFabricInfo.affected === 0) {
                  fabFlag.add(false);
                  await manager.releaseTransaction();
                  return new AllSampleDevReqResponseModel(
                    false,
                    0,
                    "Material Allocation Failed",
                    []
                  );
                } else {
                  fabFlag.add(true);
                }
              }
            } else {
              fabFlag.add(false);
              // console.log("else")
            }
          }
        }
        let trimFlag = new Set<boolean>();
        if (req.trimInfo) {
          let trimAllocation;
          for (const trimData of req.trimInfo) {
            const bomEntity = new SamplingbomEntity();
            bomEntity.sampleRequestId = save.SampleRequestId;
            bomEntity.itemType = trimData.trimType;
            bomEntity.m3ItemId = trimData.trimCode;
            bomEntity.colourId = trimData.colourId;
            bomEntity.requiredQuantity = trimData.totalRequirement;
            bomEntity.sampleItemId = save.sampleTrimInfo.find(
              (e) => e.trimCode === trimData.trimCode
            ).trimInfoId;
            saveBomDetails = await manager
              .getRepository(SamplingbomEntity)
              .save(bomEntity);
            // saveBomDetails = await this.bomRepo.save(bomEntity)

            if (
              trimData.allocatedStock.find((e) => e.checkedStatus === 1) !=
              undefined
            ) {
              const stockArray = trimData.allocatedStock.filter(
                (e) => e.checkedStatus === 1 && e.issuedQty > 0
              );
              // stockArray.push(trimData.allocatedStock.filter((e) => e.checkedStatus === 1 && e.issuedQty > 0))
              // console.log("*******")
              // console.log(trimData.allocatedStock.filter((e) => e.checkedStatus === 1 && e.issuedQty > 0));
              // console.log("*******")
              // console.log(stockArray);
              let totalAllocated = 0;
              let item: MaterialAllocationItemsEntity[] = [];
              for (const stock of stockArray) {
                // console.log(stock);
                // for (const stk of stock) {
                totalAllocated =
                  Number(totalAllocated) + Number(stock.issuedQty);
                let itemData = new MaterialAllocationItemsEntity();
                itemData.locationId = stock.locationId;
                itemData.quantity = stock.quantity;
                itemData.stockId = stock.stockId;
                itemData.allocateQuantity = stock.issuedQty;
                itemData.plantId = req.plantId;
                item.push(itemData);
                let stockUpdate = await manager
                  .getRepository(StocksEntity)
                  .update(
                    { id: stock.stockId },
                    {
                      allocateQuanty: () =>
                        `allocatd_quantity +  ${stock.issuedQty}`,
                    }
                  );
                if (stockUpdate.affected === 0) {
                  // console.log("1111111111111111111111111111111111111111111111111111111111111");
                  trimFlag.add(false);
                  await manager.releaseTransaction();
                }
                // }
              }
              let materialAllocation = new MaterialAllocationEntity();

              materialAllocation.buyerId = req.buyerId;
              materialAllocation.itemType = trimData.trimType;
              materialAllocation.m3ItemId = trimData.trimCode;
              materialAllocation.totalIssueQty = totalAllocated;
              materialAllocation.sampleOrderId = save.SampleRequestId;
              // materialAllocation.samplingBomId = saveBomDetails.samplingBomId;
              materialAllocation.sampleItemId = save.sampleTrimInfo.find(
                (e) => e.trimCode === trimData.trimCode
              ).trimInfoId;
              materialAllocation.materialAllocationinfo = item;
              materialAllocation.plantId = req.plantId;
              // console.log(materialAllocation);
              // trimAllocation = await this.creatematerialAlloction(materialAllocation);
              trimAllocation = await manager
                .getRepository(MaterialAllocationEntity)
                .save(materialAllocation);

              // console.log("$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$");
              // console.log(trimAllocation);

              if (!trimAllocation) {
                // console.log("222222222222222222222222222222222222222222222222222222222222");

                trimFlag.add(false);
                await manager.releaseTransaction();
                return new AllSampleDevReqResponseModel(
                  false,
                  0,
                  "Material Allocation Failed",
                  []
                );
              }
              // else{
              //   trimFlag.add(true)
              // }
              else {
                let trimBomStatus = BomStatusEnum.OPEN;
                if (
                  Number(trimData.totalRequirement) === Number(totalAllocated)
                ) {
                  trimBomStatus = BomStatusEnum.ALLOCATED;
                  // trimFlag.add(true);
                }
                // console.log(saveBomDetails)
                let updateSampleFabricInfo = await manager
                  .getRepository(SamplingbomEntity)
                  .update(
                    { samplingBomId: saveBomDetails.samplingBomId },
                    {
                      status: trimBomStatus,
                      receivedQuantity: () =>
                        `received_quantity + ${totalAllocated}`,
                    }
                  );
                // console.log("updateSampleFabricInfo")
                // console.log(updateSampleFabricInfo)

                if (updateSampleFabricInfo.affected === 0) {
                  // console.log("333333333333333333333333333333333333333333333333333333333333333333333");
                  trimFlag.add(false);
                  await manager.releaseTransaction();
                  return new AllSampleDevReqResponseModel(
                    false,
                    0,
                    "Material Allocation Failed",
                    []
                  );
                } else {
                  trimFlag.add(true);
                }
              }
            } else {
              trimFlag.add(false);
            }
          }
        }
        // console.log(fabFlag.has(true) + "-" + trimFlag.has(true))
        // console.log(fabFlag.has(false) + "-" + trimFlag.has(false))

        if (fabFlag.has(true) && trimFlag.has(true)) {
          let updateSampleRequestStatus = await manager
            .getRepository(SampleRequest)
            .update(
              { SampleRequestId: save.SampleRequestId },
              { lifeCycleStatus: LifeCycleStatusEnum.READY_FOR_PRODUCTION }
            );
          // console.log(updateSampleRequestStatus)
          if (updateSampleRequestStatus.affected === 0) {
            await manager.releaseTransaction();
            return new AllSampleDevReqResponseModel(
              false,
              0,
              "Material Allocation Failed",
              []
            );
          }
        }
      } else {
        await manager.releaseTransaction();
        return new AllSampleDevReqResponseModel(
          false,
          0,
          "SampleDevelopmentRequest creation Failed",
          []
        );
      }
      if (save && saveBomDetails) {
        await manager.completeTransaction();
        // console.log("%%%%%%%%%%%%%%%%%%%%%%%%%%%%%");
        // console.log(save);

        for (const res of req.fabricInfo) {
          save.sampleReqFabricInfo.find(
            (rec) =>
              rec.fabricCode === res.fabricCode && rec.colourId == res.colourId
          )["fabricUpload"] = res.fabricUpload;
        }

        const req1 = new SourcingRequisitionReq(
          req.styleId,
          new Date(),
          "",
          new Date(),
          indentFabInfo,
          indentTrimInfo,
          save.SampleRequestId,
          0
        );
        // const raiseIndent = await this.indentService.createItems(req1);
        // if(raiseIndent.status){

        // return new AllSampleDevReqResponseModel(true, 1, 'SampleDevelopmentRequest created successfully', [save])
        const query = `select p.pattern_name as patternName ,p.pattern_id from pattern p`;
        const request = await this.dataSource.query(query);

        try {
          return new AllSampleDevReqResponseModel(
            true,
            1,
            "Sample Development Request created successfully",
            [save]
          );
        } catch (error) {
          // Handle errors gracefully
          console.error("Error sending email:", error);
          return new AllSampleDevReqResponseModel(
            false,
            0,
            "Failed to create Sample Development Request",
            []
          );
        }

        // }
        // else {
        //   return new AllSampleDevReqResponseModel(false, 0, 'SampleDevelopmentRequest creation Failed', [])
        // }
      } else {
        return new AllSampleDevReqResponseModel(
          false,
          0,
          "SampleDevelopmentRequest creation Failed",
          []
        );
      }
    } catch (err) {
      // console.log(err);
      await manager.releaseTransaction();
      throw err;
    }
  }

  async fabricUpload(filePath: any, data: any): Promise<UploadResponse> {
    // console.log(filePath);
    // console.log(data);
    // console.log(JSON.parse(data));

    const manager = new GenericTransactionManager(this.dataSource);
    try {
      let flag = true;
      await manager.startTransaction();
      for (const [index, value] of JSON.parse(data).entries()) {
        // console.log("********************")
        // console.log(value);
        // console.log(index);

        const updateFilePath = await manager
          .getRepository(SampleReqFabricinfoEntity)
          .update(
            { fabricInfoId: value.fabricInfoId },
            {
              fileName: `${filePath[index].filename}`,
              filePath: `${filePath[index].path}`,
            }
          );
        // console.log(updateFilePath)
        if (!(updateFilePath.affected > 0)) {
          flag = false;
        }
      }
      if (flag) {
        await manager.completeTransaction();
        return new UploadResponse(true, 11, "uploaded successfully", filePath);
      } else {
        await manager.releaseTransaction();
        return new UploadResponse(false, 11, "uploaded failed", filePath);
      }
    } catch (error) {
      await manager.releaseTransaction();
      console.log(error);
    }
  }

  async trimUpload(filePath: any, data: any): Promise<UploadResponse> {
    // console.log(filePath);
    // console.log(data);
    // console.log(JSON.parse(data));

    const manager = new GenericTransactionManager(this.dataSource);
    try {
      let flag = true;
      await manager.startTransaction();
      for (const [index, value] of JSON.parse(data).entries()) {
        // console.log("@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@")
        // console.log(value);
        // console.log(index);

        const updateFilePath = await manager
          .getRepository(SampleRequestTriminfoEntity)
          .update(
            { trimInfoId: value.trimInfoId },
            {
              fileName: `${filePath[index].filename}`,
              filePath: `${filePath[index].path}`,
            }
          );
        // console.log(updateFilePath)
        if (!(updateFilePath.affected > 0)) {
          flag = false;
        }
      }
      if (flag) {
        await manager.completeTransaction();
        return new UploadResponse(true, 11, "uploaded successfully", filePath);
      } else {
        await manager.releaseTransaction();
        return new UploadResponse(false, 11, "uploaded failed", filePath);
      }
    } catch (error) {
      await manager.releaseTransaction();
      console.log(error);
    }
  }

  async UpdateFilePath(
    filePath: any,
    SampleRequestId: number
  ): Promise<UploadResponse> {
    // console.log('upload service id---------------', filePath)
    // console.log('upload service id---------------', SampleRequestId)
    try {
      // let filePathUpdate;
      // filePathUpdate = await this.sampleRepo.update({ SampleRequestId: SampleRequestId }, { fileName: filename, filepath: filePath })
      let flag = true;
      const entities = [];
      for (const res of filePath) {
        const entity = new UploadFilesEntity();
        entity.fileName = res.filename;
        entity.filePath = res.path;
        entity.sampleRequestId = SampleRequestId;
        entity.createdUser = "admin";
        entities.push(entity);
      }
      const uploadDoc = await this.uploadFilesRepository.save(entities);
      if (!uploadDoc) {
        flag = false;
      }
      if (flag) {
        return new UploadResponse(true, 11, "uploaded successfully", filePath);
      } else {
        return new UploadResponse(false, 11, "uploaded failed", filePath);
      }
    } catch (error) {
      console.log(error);
    }
  }

  async getAllFilesDataByReqId(
    req: SampleIdRequest
  ): Promise<CommonResponseModel> {
    const data = await this.uploadFilesRepository.find({
      where: { sampleRequestId: req.sampleRequestId },
    });
    if (data.length === 0) {
      return new CommonResponseModel(false, 0, "data not found", []);
    }
    return new CommonResponseModel(true, 123, "", data);
  }

  async getAllStyleNo(): Promise<CommonResponseModel> {
    const details = await this.sampleRepo.getAllStyleNo();
    if (details.length > 0) {
      return new CommonResponseModel(true, 1, "data retrieved", details);
    } else {
      return new CommonResponseModel(false, 0, "data not found");
    }
  }

  async getFabricCodes(): Promise<CommonResponseModel> {
    const details =
      'SELECT ri.product_group_id as productGroupId,rm_item_id AS fabricId,item_code AS fabricCode,ri.product_group_id FROM rm_items ri LEFT JOIN product_group pg ON pg.product_group_id=ri.product_group_id WHERE product_group="Fabric"';
    const result = await this.sampleRepo.query(details);
    if (details.length > 0) {
      return new CommonResponseModel(true, 1, "data retrieved", result);
    } else {
      return new CommonResponseModel(false, 0, "data not found", []);
    }
  }

  async getTrimCodes(): Promise<CommonResponseModel> {
    const details =
      'SELECT rm_item_id AS trimId,item_code AS trimCode,ri.product_group_id FROM rm_items ri LEFT JOIN product_group pg ON pg.product_group_id=ri.product_group_id WHERE product_group not in( "Fabric")';
    const result = await this.sampleRepo.query(details);
    if (details.length > 0) {
      return new CommonResponseModel(true, 1, "data retrieved", result);
    } else {
      return new CommonResponseModel(false, 0, "data not found", []);
    }
  }

  async getTrimType(): Promise<CommonResponseModel> {
    try {
      const query =
        'SELECT product_group_id AS productGroupId,product_group AS productGroup FROM product_group      WHERE product_group NOT IN("Fabric") AND is_active=1';
      const result = await this.sampleRepo.query(query);
      if (result) {
        return new CommonResponseModel(
          true,
          1,
          "data retivedsucessfully",
          result
        );
      } else {
        return new CommonResponseModel(false, 0, "No Data Found", []);
      }
    } catch (err) {
      throw err;
    }
  }
  async getTrimCodeAgainstTrimType(
    req: ProductGroupReq
  ): Promise<CommonResponseModel> {
    try {
      const query =
        'SELECT product_group AS productGroup,rm_item_id AS trimId,item_code AS trimCode,ri.product_group_id FROM rm_items ri LEFT JOIN product_group pg ON pg.product_group_id=ri.product_group_id     WHERE product_group NOT IN("fabric") AND ri.product_group_id=' +
        req.productGroupId +
        "";
      const result = await this.sampleRepo.query(query);
      if (result) {
        return new CommonResponseModel(
          true,
          1,
          "data retivedsucessfully",
          result
        );
      } else {
        return new CommonResponseModel(false, 0, "No Data Found", []);
      }
    } catch (err) {
      throw err;
    }
  }

  async getM3StyleCode(): Promise<CommonResponseModel> {
    const manager = this.dataSource;
    let rawData;
    rawData =
      " SELECT m3_style_code AS m3StyleCode ,m3_style_id AS m3StyleId FROM `m3_style` WHERE is_active=1";
    const rmData = await manager.query(rawData);
    if (rmData) {
      return new CommonResponseModel(
        true,
        1111,
        "Data retrieved",
        Object.values(rmData)
      );
    } else {
      return new CommonResponseModel(false, 0, "Data Not retrieved", []);
    }
  }
  async getSampleInventory(): Promise<CommonResponseModel> {
    const inventoryData = this.dataSource;
    let rawDatas;
    rawDatas = `SELECT  m3.trim_code AS item_code,m3.trim_type AS item_type,s.request_no,sf.colour_id,m3i.shrinkage,m3i.weight,m3i.weave,s.status FROM sample_request s
    LEFT JOIN sample_request_fabric_info sf ON sf.sample_request_id = s.sample_request_id
    LEFT JOIN sample_request_trim_info st ON st.sample_request_id = s.sample_request_id
    LEFT JOIN  m3_trims m3 ON m3.m3_trim_Id = st.trim_code
    LEFT JOIN  m3_items m3i ON m3i.m3_items_Id= sf.fabric_code
  UNION ALL
  SELECT  m3i.item_code AS item_code,m3i.fabric_type AS item_type ,s.request_no,sf.colour_id,m3i.shrinkage,m3i.weight,m3i.weave,s.status FROM sample_request s
    LEFT JOIN sample_request_fabric_info sf ON sf.sample_request_id = s.sample_request_id
    LEFT JOIN sample_request_trim_info st ON st.sample_request_id = s.sample_request_id
    LEFT JOIN  m3_trims m3 ON m3.m3_trim_Id = st.trim_code
    LEFT JOIN  m3_items m3i ON m3i.m3_items_Id= sf.fabric_code`;

    const result = await inventoryData.query(rawDatas);
    if (result) {
      return new CommonResponseModel(
        true,
        1,
        "data retrived sucessfully",
        result
      );
    } else {
      return new CommonResponseModel(false, 0, "no data found", []);
    }
  }

  async getAllRequestNo(): Promise<CommonResponseModel> {
    const records = await this.sampleRepo.find();
    if (records.length)
      return new CommonResponseModel(
        true,
        65441,
        "Data Retrieved Successfully",
        records
      );
    else return new CommonResponseModel(false, 0, "No data found");
  }

  async getAllBuyers(): Promise<CommonResponseModel> {
    const records = await this.sampleRepo.find();
    if (records.length)
      return new CommonResponseModel(
        true,
        65441,
        "Data Retrieved Successfully",
        records
      );
    else return new CommonResponseModel(false, 0, "No data found");
  }

  async getAllAllocatedRequestNo(
    req?: BuyerRefNoRequest
  ): Promise<CommonResponseModel> {
    // const buyerdata = `select buyer_id from buyers where external_ref_number = '${req.buyerRefNo}'`;
    // const res = await this.dataSource.query(buyerdata)
    // const buyerId = res[0].buyer_id
    // console.log(buyerId, 'buyerIdbuyerId')
    const records = await this.sampleRepo.find({
      where: { lifeCycleStatus: LifeCycleStatusEnum.MATERIAL_ALLOCATED },
    });
    if (records.length)
      return new CommonResponseModel(
        true,
        65441,
        "Data Retrieved Successfully",
        records
      );
    else return new CommonResponseModel(false, 0, "No data found");
  }

  async getAllApprovedRequestNo(
    req?: BuyerRefNoRequest
  ): Promise<CommonResponseModel> {
    // console.log(req);
    let buyerId;
    if (req?.buyerRefNo !== null && req?.buyerRefNo != "admin") {
      const buyerdata = `select buyer_id from buyers where external_ref_number = '${req.buyerRefNo}'`;
      const res = await this.dataSource.query(buyerdata);
      buyerId = res[0].buyer_id;
    }
    let records;
    if (req?.buyerRefNo != null && req?.buyerRefNo != "admin") {
      records = await this.sampleRepo.find({
        where: {
          lifeCycleStatus: LifeCycleStatusEnum.READY_FOR_PRODUCTION,
          buyer: { buyerId: buyerId },
        },
      });
    } else {
      records = await this.sampleRepo.find({
        where: { lifeCycleStatus: LifeCycleStatusEnum.READY_FOR_PRODUCTION },
      });
    }
    if (records.length)
      return new CommonResponseModel(
        true,
        65441,
        "Data Retrieved Successfully",
        records
      );
    else return new CommonResponseModel(false, 0, "No data found");
  }

  async createSampling(req: SampleInventoryLog): Promise<CommonResponseModel> {
    // console.log(req, 'service')
    let save;
    try {
      const conversion = [];
      for (const rec of req.addressInfo) {
        const entity = new SampleInventoryLogEntity();
        const size = new Size();
        size.sizeId = rec.size;
        entity.size = size;
        entity.quantity = rec.quantity;
        const lo = new Location();
        lo.locationId = rec.location;
        entity.locationName = lo;
        const oInventory = new OperationInventory();
        oInventory.operationInventoryId = req.operation;
        entity.operation = oInventory;
        oInventory.locationMapped = rec.quantity;
        conversion.push(entity);
      }
      save = await this.logRepo.save(conversion);
      if (save) {
        const qtyTotal = req.addressInfo.reduce(
          (a, c) => a + Number(c.quantity),
          0
        );
        const mappedQty = await this.dataSource
          .getRepository(OperationInventory)
          .findOne({
            select: ["locationMapped"],
            where: { operationInventoryId: req.operation },
          });
        const total = qtyTotal + Number(mappedQty.locationMapped);
        if (qtyTotal > Number(mappedQty.locationMapped)) {
          throw new ErrorResponse(
            65465,
            "Do Not Enter The Quantity To More Than Remaing Mapped Quantity"
          );
        } else {
          await this.dataSource
            .getRepository(OperationInventory)
            .update(
              { operationInventoryId: req.operation },
              { locationMapped: total }
            );
          return new CommonResponseModel(true, 1223, "created sucesses", save);
        }
      }
    } catch (error) {
      return new CommonResponseModel(false, 321, "Not created", error);
    }
  }

  async getAllSmaplingDevData(req?: any): Promise<CommonResponseModel> {
    const manager = this.dataSource;
    let rawData = `SELECT sb.rm_item_id as rmItemId,sb.colour_id as colourId,sr.m3_style_no as m3StleNo,sr.style_id as styleId,sb.sampling_bom_id,sr.sample_request_id, sr.request_no AS requestNo, sr.m3_style_no, sb.rm_item_id, ri.item_code, sb.required_quantity as requiredQuantity,sb.created_at, sb.assigned_quantity,sb.colour_id,co.colour,st.style,bu.buyer_name,pg.product_group,ss.quantity,fa.name   FROM sampling_bom sb LEFT JOIN sample_request sr ON sb.sample_request_id = sr.sample_request_id LEFT JOIN rm_items ri ON ri.rm_item_id LEFT JOIN colour co ON co.colour_id = sb.colour_id  LEFT JOIN style st ON st.style_id = sr.style_id LEFT JOIN buyers bu ON bu.buyer_id = sr.buyer_id LEFT JOIN product_group pg ON pg.product_group_id = sb.product_group_id LEFT JOIN stocks ss ON ss.item_type_id = sb.rm_item_id LEFT JOIN factory fa ON fa.id=sr.facility_id 
    WHERE sr.sample_request_id IS NOT NULL `;
    if (req.buyerName) {
      rawData = rawData + ' and bu.buyer_name = "' + req.buyerName + '"';
    }
    if (req.requestNo) {
      rawData = rawData + ' and sr.request_no = "' + req.requestNo + '"';
    }
    if (req.style) {
      rawData = rawData + ' and sr.style = "' + req.style + '"';
    }
    rawData = rawData + " group by sb.sampling_bom_id ";

    const rmData = await manager.query(rawData);
    // console.log(rmData, "4444444444")
    // console.log("**********************************************************************")

    if (rmData.length > 0) {
      const groupedData = rmData.reduce((result, item) => {
        // console.log(item, "ittttteemmmm")
        const samplerequestid = item.sample_request_id;
        const requestNo = item.requestNo;
        const buyers = item.buyer_name;
        const date = item.created_at;
        const style = item.style;
        const unit = item.name;
        const styleId = item.styleId;
        const requiredQuantity = item.requiredQuantity;
        const m3StleNo = item.m3StleNo;
        const colourId = item.colourId;
        const rmItemId = item.rmItemId;
        if (!result[requestNo]) {
          result[requestNo] = {
            request_no: requestNo,
            sample_request_id: samplerequestid,
            buyer_name: buyers,
            created_at: date,
            style: style,
            name: unit,
            styleId: styleId,
            requiredQuantity: requiredQuantity,
            m3StleNo: m3StleNo,
            colourId: colourId,
            rmItemId: rmItemId,
            sm: [],
          };
        }

        result[requestNo].sm.push({
          code: item.item_code,
          // buyers: item.buyer_name,
          fabricName: item.product_group,
          consumption: item.required_quantity,
          quantity: item.quantity,
          color: item.colour,
          styleId: item.styleId,
          requiredQuantity: item.requiredQuantity,
          m3StleNo: item.m3StleNo,
          colourId: item.colourId,
          rmItemId: item.rmItemId,
          // style:item.style,
          // date:item.created_at,
        });

        return result;
      }, {});

      return new CommonResponseModel(
        true,
        1111,
        "Data retrieved",
        Object.values(groupedData)
      );
    }

    return new CommonResponseModel(false, 0, "Data Not retrieved", []);
  }
  async creatematerialAlloction(
    req: MaterialAllocationDTO
  ): Promise<CommonResponseModel> {
    const manager = new GenericTransactionManager(this.dataSource);
    const queryManager = this.dataSource;
    try {
      let save;
      // const filteredData = req.filter(item => item.checkedStatus === 1);
      // const transformedData = filteredData.reduce((acc, item) => {
      //   // console.log(transformedData,'transformedData')
      //   const foundIndex = acc.findIndex(
      //     (el) =>
      //       el.sampleOrderId === item.sampleOrderId &&
      //       el.sampleItemId === item.sampleItemId &&
      //       el.m3ItemId === item.m3ItemId &&
      //       el.buyerId ===item.buyerId
      //   );

      //   if (foundIndex !== -1) {
      //     acc[foundIndex].itemData.push({
      //       quantity: item.quantity,
      //       stockId: item.stockId,
      //       LocationId: item.LocationId,
      //       checkedStatus: item.checkedStatus,
      //       issuedQty: item.issuedQty
      //     });
      //   } else {
      //     acc.push({
      //       itemType: item.itemType,
      //       sampleOrderId: item.sampleOrderId,
      //       sampleItemId: item.sampleItemId,
      //       m3ItemId: item.m3ItemId,
      //       buyerId:item.buyerId,
      //       itemData: [
      //         {
      //           quantity: item.quantity,
      //           stockId: item.stockId,
      //           LocationId: item.LocationId,
      //           checkedStatus: item.checkedStatus,
      //           issuedQty: item.issuedQty
      //         }
      //       ]
      //     });
      //   }

      //   return acc;
      // }, []);
      // // console.log(transformedData);
      let materialitemdata: MaterialAllocationItemsEntity[] = [];
      // for(const mainData of transformedData ){
      const entity = new MaterialAllocationEntity();
      entity.buyerId = req.buyerId;
      entity.itemType = req.itemType;
      entity.sampleOrderId = req.sampleOrderId;
      entity.sampleItemId = req.sampleItemId;
      entity.m3ItemId = req.m3ItemId;
      entity.totalIssueQty = req.allocatioQuantity;
      entity.status = MaterialStatusEnum.MATERIAL_ALLOCATED;
      let totalQty = 0;
      for (const itemData of req.allocatedItems) {
        const itemEntity = new MaterialAllocationItemsEntity();
        itemEntity.locationId = itemData.LocationId;
        itemEntity.stockId = itemData.stockId;
        itemEntity.quantity = itemData.quantity;
        itemEntity.allocateQuantity = itemData.allocatioQuantity;
        materialitemdata.push(itemEntity);
        totalQty = Number(totalQty) + Number(itemData.allocatioQuantity);
      }
      entity.materialAllocationinfo = materialitemdata;
      // console.log(entity)
      await manager.startTransaction();
      save = await manager.getRepository(MaterialAllocationEntity).save(entity);
      // }
      // console.log(save)
      // console.log('***********************************8')
      // console.log(materialitemdata);
      if (save) {
        // console.log("save done");
        let updateStockFlag = true;
        for (const itemData of materialitemdata) {
          // console.log(itemData);
          const update = await manager.getRepository(StocksEntity).update(
            { id: itemData.stockId },
            {
              allocateQuanty: () =>
                `allocatd_quantity +  ${itemData.allocateQuantity}`,
            }
          );
          // console.log(update);
          // console.log("update Stock");
          if (!update.affected) {
            updateStockFlag = false;
            await manager.releaseTransaction();
            break;
          }
        }
        let bomUpdateFlag = true;
        let bomStatus = BomStatusEnum.OPEN;
        if (req.allocatioQuantity >= req.toBeProcured) {
          bomStatus = BomStatusEnum.ALLOCATED;
        }
        // for(const mainData of transformedData ){
        let updateBomStatus = await manager
          .getRepository(SamplingbomEntity)
          .update(
            { samplingBomId: req.samplingBomId },
            {
              status: bomStatus,
              receivedQuantity: () => `received_quantity + ${totalQty}`,
            }
          );
        // console.log("updateBomStatus");
        // console.log(updateBomStatus);

        if (updateBomStatus.affected < 1) {
          bomUpdateFlag = false;
          await manager.releaseTransaction();
        }

        // }
        let updateSampleOrderStatus;
        let getBomStatusquery =
          "Select * from sampling_bom where status!= 'Allocated' and sample_request_id = " +
          req.sampleOrderId;
        let getBomStatus = await queryManager.query(getBomStatusquery);
        // let getBomStatus = await manager.getRepository(SamplingbomEntity).find({where:{status: Not(BomStatusEnum.ALLOCATED),sampleRequestId: transformedData[0].sampleOrderId}});
        // console.log("getBomStatus")
        // console.log(getBomStatus)

        if (getBomStatus.length - 1 < 1) {
          updateSampleOrderStatus = await manager
            .getRepository(SampleRequest)
            .update(
              { SampleRequestId: req.sampleOrderId },
              { lifeCycleStatus: LifeCycleStatusEnum.READY_FOR_PRODUCTION }
            );
          // console.log(updateSampleOrderStatus);
          // console.log(bomUpdateFlag);
          // console.log(updateStockFlag);

          if (!updateSampleOrderStatus || !bomUpdateFlag || !updateStockFlag) {
            await manager.releaseTransaction();
            return new CommonResponseModel(
              false,
              1,
              "Something Went Wrong",
              []
            );
          } else {
            await manager.completeTransaction();
            return new CommonResponseModel(
              true,
              1,
              "Material Allocation Request Raise"
            );
          }
        } else {
          await manager.completeTransaction();
          return new CommonResponseModel(
            true,
            1,
            "Material Allocation Request Raise"
          );
        }
      } else {
        await manager.releaseTransaction();
        return new CommonResponseModel(false, 1, "Something Went Wrong", []);
      }
    } catch (err) {
      console.log(err);
      await manager.releaseTransaction();
      throw err;
    }
  }

  async getSampleRequestReport(
    req?: SamplerawmaterialStausReq
  ): Promise<CommonResponseModel> {
    try {
      console.log(req);
      let getBuyerByIds;
      if (req.extRefNo != undefined && req.extRefNo != "admin") {
        let employeId = await this.employeeDetailsRepo.findOne({
          where: { emial: req.email },
        });
        console.log(employeId);
        getBuyerByIds = await this.employeeBuyerMappingService.getMappedBuyers({
          employeeId: employeId?.employeeId,
        });
        console.log(getBuyerByIds);
      }
      const manager = this.dataSource;
      // let query3
      // let query1=`SELECT required_quantity-received_quantity-IF(po_quantity IS NOT NULL,po_quantity,0) AS bomQuantity,srf.consumption-po_quantity AS sampleBalanceQuanty,srf.consumption AS sampleQuantity,poi.po_quantity AS poquantity, rp.rack_position_name as locationName ,sr.location_id as location,brand_name as brandName, s.style AS styleName,sr.life_cycle_status AS lifeCycleStatus,b.buyer_name AS buyername,sr.request_no AS sampleReqNo,c.colour AS colourName, mi.item_code AS itemCode,sb.sample_request_id AS sampleRequestid,sb.item_type AS itemType,sb.m3_item_id AS m3ItemId,sb.required_quantity AS requiredQuantity, sb.received_quantity AS receivedQuantity,sb.colour_id AS colorId,st.quantity AS avilableQuantity, sr.style_id AS styleId,sr.buyer_id AS buyerId FROM sampling_bom sb
      //  LEFT JOIN  sample_request_fabric_info srf ON srf.sample_request_id=sb.sample_request_id AND srf.fabric_code=sb.m3_item_id
      //   LEFT JOIN sample_request sr ON sr.sample_request_id=sb.sample_request_id
      //    LEFT JOIN stocks st ON st.m3_item =sb.m3_item_id AND sr.buyer_id=st.buyer_id AND sb.item_type IN("fabric")
      //      LEFT JOIN m3_items mi ON mi.m3_items_Id=sb.m3_item_id
      //      LEFT JOIN colour c ON c.colour_id=sb.colour_id
      //       LEFT JOIN buyers b ON b.buyer_id=sr.buyer_id
      //        LEFT JOIN style s ON s.style_id=sr.style_id left join brands bs on bs.brand_id=sr.brand_id
      //        left join rack_position rp on rp.position_Id =sr.location_id
      //         LEFT JOIN purchae_order_items poi ON poi.sample_item_id =srf.fabric_info_id   WHERE sb.item_type IN("Fabric")  AND st.quantity IS NULL AND (required_quantity-IF(po_quantity IS NOT NULL,po_quantity,0)) >0`
      // if(req.extRefNo){
      //   query1 = query1+ ` and b.external_ref_number = '${req.extRefNo}'`
      // }

      // let query2=`select required_quantity-received_quantity-IF(po_quantity IS NOT NULL,po_quantity,0) AS bomQuantity,srt.consumption-po_quantity AS sampleBalanceQuanty,srt.consumption AS sampleQuantity,poi.po_quantity AS poquantity,rp.rack_position_name as locationName,sr.location_id as location,brand_name as brandName, s.style as styleName,sr.life_cycle_status AS lifeCycleStatus,b.buyer_name AS buyername,sr.request_no AS sampleReqNo,c.colour AS colourName,mi.trim_code AS itemCode,sb.sample_request_id AS sampleRequestid,sb.item_type AS itemType,sb.m3_item_id AS m3ItemId,sb.required_quantity AS requiredQuantity,sb.received_quantity AS receivedQuantity,sb.colour_id AS colorId,st.quantity AS avilableQuantity , sr.style_id AS styleId,sr.buyer_id AS buyerId FROM sampling_bom sb
      // LEFT JOIN sample_request_trim_info srt ON srt.sample_request_id=sb.sample_request_id AND srt.trim_code=sb.m3_item_id
      //  LEFT JOIN sample_request sr ON sr.sample_request_id=sb.sample_request_id
      //   LEFT JOIN stocks st ON st.m3_item =sb.m3_item_id AND sr.buyer_id=st.buyer_id AND st.item_type IN("fabric")
      //   LEFT JOIN m3_trims mi ON mi.m3_trim_Id=sb.m3_item_id
      //     LEFT JOIN colour c ON c.colour_id=sb.colour_id
      //    LEFT JOIN buyers b ON b.buyer_id=sr.buyer_id
      //    LEFT JOIN style s ON s.style_id=sr.style_id left join brands bs on bs.brand_id=sr.brand_id
      //    left join rack_position rp on rp.position_Id =sr.location_id
      //     LEFT JOIN purchae_order_items poi ON poi.sample_item_id =srt.trim_info_id
      //  WHERE sb.item_type NOT IN ("Fabric")  AND st.quantity IS NULL AND (required_quantity-IF(po_quantity IS NOT NULL,po_quantity,0)) >0`
      //  if(req.extRefNo){
      //   query2 = query2+ ` and b.external_ref_number = '${req.extRefNo}'`
      // }
      // if (req.buyerId == undefined && req.sampleReqNo == undefined && req.styleId == undefined){
      //   query3 = query1+'   UNION ALL'+' '+query2
      // }
      // // if(req.sampleReqNo != undefined){
      // //   query1=query1+' and sr.sample_request_id='+req.sampleReqNo+''
      // //   query2=query2+' and sr.sample_request_id='+req.sampleReqNo+''
      // //   query3=query1+'   UNION ALL '+query2
      // // }
      // if (req.sampleReqNo != undefined) {
      //   query1 = query1 + ' AND sr.sample_request_id=' + req.sampleReqNo;
      //   query2 = query2 + ' AND sr.sample_request_id=' + req.sampleReqNo;
      //   query3 = query1 + ' UNION ALL ' + query2;
      // }
      // if (req.buyerId != undefined) {
      //   query1 = query1 + ' AND sr.buyer_id=' + req.buyerId;
      //   query2 = query2 + ' AND sr.buyer_id=' + req.buyerId;
      //   query3 = query1 + ' UNION ALL ' + query2;
      // }
      // if (req.styleId != undefined) {
      //   query1 = query1 + ' AND sr.style_id=' + req.styleId;
      //   query2 = query2 + ' AND sr.style_id=' + req.styleId;
      //   query3 = query1 + ' UNION ALL ' + query2;
      // }

      // const rmData = await manager.query(query3);

      // console.log("rmDatarmDatarmDatarmDatarmDatarmData")
      // console.log(rmData)

      // if (rmData.length > 0) {
      //   const groupedData = rmData.reduce((result, item) => {
      //     const sampleReqNo = item.sampleReqNo;
      //     const buyername = item.buyername;
      //     const status = item.lifeCycleStatus;
      //     const styleName=item.styleName
      //     const locationName=item.locationName
      //     const location=item.location
      //     const brandName=item.brandName
      //     const style=item.styleId
      //     const buyerId=item.buyerId
      //     if (!result[sampleReqNo]) {
      //       result[sampleReqNo] = {
      //         sampleReqNo: sampleReqNo,
      //         buyerName: buyername,
      //         status: status,
      //         stylename:styleName,
      //         locationName:locationName,
      //         location:location,
      //         brandName:brandName,
      //         styleId:style,
      //         buyerId:buyerId,
      //         sm: [],
      //       };
      //     }

      //     result[sampleReqNo].sm.push(
      //       {
      //         samplingBomId:item.samplingBomId,
      //         sampleRequestid:item.sampleRequestid,
      //         m3ItemId:item.m3ItemId,
      //         colourName:item.colourName,
      //         itemCode:item.itemCode,
      //         fabricType: item.itemType,
      //         quantity: item.requiredQuantity,
      //         assignedQuantity:item.assigned_quantity,
      //         bomQuantity:item.bomQuantity,
      //         styleId:item.styleId,
      //         buyerId:buyerId,
      //       }
      //     );
      //     console.log(result)
      //     return result;
      //   }, {});
      //   console.log(Object.values(groupedData))
      //   return new CommonResponseModel(true, 1111, 'Data retrieved', Object.values(groupedData));

      //   }
      let query1 = `SELECT sr.plant_id AS plantId, p.plant_name AS plantName,fc.colour_id,sb.sample_item_id AS sampleItemId,sb.sampling_bom_id AS samplingBomId,required_quantity-received_quantity-IF(po_quantity IS NOT NULL,po_quantity,0) AS bomQuantity, required_quantity-received_quantity-IF(po_quantity IS NOT NULL,po_quantity,0) AS sampleBalanceQuanty,sb.required_quantity AS sampleQuantity,poi.po_quantity AS poquantity, rp.rack_position_name as locationName ,sr.location_id as location,brand_name as brandName, s.style AS styleName,sr.life_cycle_status AS lifeCycleStatus,b.buyer_name AS buyername,sr.request_no AS sampleReqNo,IF(sb.item_type = "Fabric",c.colour,tc.colour) AS colourName, IF(sb.item_type = "Fabric", CONCAT(mi.item_code,'-',mi.description), mt.trim_code) AS itemCode,sb.sample_request_id AS sampleRequestid,sb.item_type AS itemType,sb.m3_item_id AS m3ItemId,sb.required_quantity AS requiredQuantity, sb.received_quantity AS receivedQuantity,sb.colour_id AS colorId,(st.quantity-st.allocatd_quantity-st.transfered_quantity) AS avilableQuantity, sr.style_id AS styleId,sr.buyer_id AS buyerId, IF(sb.item_type = "Fabric", mi.hsn_code, mt.hsn_code) AS hsnCode, fc.colour AS fabColor,mi.shade_no as shadeNo FROM sampling_bom sb 
        LEFT JOIN  sample_request_fabric_info srf ON srf.sample_request_id = sb.sample_request_id and srf.fabric_info_id=sb.sample_item_id AND sb.item_type='Fabric' 
        LEFT JOIN sample_request_trim_info srt ON srt.sample_request_id=sb.sample_request_id and srt.trim_info_id=sb.sample_item_id AND sb.item_type!='Fabric'
        LEFT JOIN sample_request sr ON sr.sample_request_id=sb.sample_request_id  
        LEFT JOIN plants p on p.plant_id = sr.plant_id
          LEFT JOIN stocks st ON st.m3_item =sb.m3_item_id AND sr.buyer_id=st.buyer_id AND st.item_type = sb.item_type and st.grn_type = "INDENT"
            LEFT JOIN m3_items mi ON mi.m3_items_Id=sb.m3_item_id and sb.item_type = "Fabric" 
            LEFT JOIN m3_trims mt ON mt.m3_trim_Id=sb.m3_item_id and sb.item_type != "Fabric"
            LEFT JOIN colour fc ON fc.colour_id=srf.fab_colour_id
            LEFT JOIN colour c ON c.colour_id=sb.colour_id and sb.item_type = "Fabric"
            LEFT JOIN colour tc ON tc.colour_id=mt.color_id and sb.item_type != "Fabric"
            LEFT JOIN buyers b ON b.buyer_id=sr.buyer_id
              LEFT JOIN style s ON s.style_id=sr.style_id left join brands bs on bs.brand_id=sr.brand_id 
              left join rack_position rp on rp.position_Id =sr.location_id  
              LEFT JOIN purchae_order_items poi ON poi.sample_item_id =sb.sample_item_id AND poi.item_type LIKE '%${req.tab}%' WHERE (required_quantity-received_quantity-IF((st.quantity-st.allocatd_quantity-st.transfered_quantity) IS NULL, 0, (st.quantity-st.allocatd_quantity-st.transfered_quantity))-IF(po_quantity IS NOT NULL,po_quantity,0)) >0 and sr.life_cycle_status NOT IN ('CLOSED','REJECTED')`;
      if (req.extRefNo != null && req.extRefNo != "admin") {
        query1 = query1 + ` and b.buyer_id IN (${getBuyerByIds.data.buyerIds})`;
      }

      if (req.sampleReqNo != undefined) {
        query1 = query1 + " AND sr.sample_request_id=" + req.sampleReqNo;
      }
      if (req.buyerId != undefined) {
        query1 = query1 + " AND sr.buyer_id=" + req.buyerId;
      }
      if (req.styleId != undefined) {
        query1 = query1 + " AND sr.style_id=" + req.styleId;
      }
      if (req.tab != undefined) {
        query1 = query1 + ` AND sb.item_type LIKE '%${req.tab}%'`;
      }
      query1 =
        query1 +
        ` group by sb.sampling_bom_id order by sr.request_no, b.buyer_name, sb.item_type DESC`;
      const rmData = await manager.query(query1);
      // console.log(rmData)
      // console.log(rmData.length)

      if (rmData.length > 0) {
        return new CommonResponseModel(
          true,
          1,
          "Sampling Bom data retrived successfully. ",
          rmData
        );
      } else {
        return new CommonResponseModel(
          true,
          1,
          "Sampling Bom data retrived successfully. ",
          rmData
        );
      }
    } catch (err) {
      throw err;
    }
  }

  // async getAllMaterialAllocation(req?:buyerReq) : Promise<CommonResponseModel> {
  //   try{
  //     const data = await this.matAllRepo.getallMaterialAllocation(req)
  //     const map = new Map<number,AllocateMaterial >()
  //     if(data.length == 0){
  //       return new AllocateMaterialResponseModel(false,0,'No data found',[])
  //     } else {
  //       for(const rec of data){
  //         if(!map.has(rec.material_allocation_id)){
  //           map.set(rec.material_allocation_id,new AllocateMaterial(rec.material_allocation_id,rec.item_type,rec.sample_order_id,rec.sample_item_id,rec.m3_item_id,rec.buyer_id,rec.status,[],rec.buyer_name,"admin") )
  //         }

  //         map.get(rec.material_allocation_id).materialAllocateIteminfo.push(new allocateMaterialItems(rec.material_allocation_items_id,rec.quantity,rec.stock_id,rec.location_id,rec.allocate_quantity,rec.material_allocation_id,rec.location_name,"admin") )
  //     }
  //     const allocateMaterial: AllocateMaterial[] = [];
  //     map.forEach((e) => allocateMaterial.push(e))
  //           return new AllocateMaterialResponseModel(true,1,'Data retrieved',allocateMaterial)
  //   }

  //   } catch(err){
  //     throw err
  //   }
  // }

  async getAllMaterialAllocation(req?: buyerReq): Promise<CommonResponseModel> {
    try {
      const data = await this.matAllRepo.getallMaterialAllocation(req);

      if (data) {
        return new CommonResponseModel(
          true,
          0,
          "Data retrived Successfully",
          data
        );
      } else {
        return new CommonResponseModel(false, 1, "No Data Found", []);
      }
    } catch (err) {
      throw err;
    }
  }

  async getallMaterialAllocationItemsById(
    req: MaterialallitemsReq
  ): Promise<CommonResponseModel> {
    try {
      const data = await this.matAllitemRepo.getallMaterialAllocationItemsById(
        req
      );

      if (data) {
        return new CommonResponseModel(
          true,
          0,
          "Data retrived Successfully",
          data
        );
      } else {
        return new CommonResponseModel(false, 1, "No Data Found", []);
      }
    } catch (err) {
      throw err;
    }
  }

  async updateStatus(req?: statusReq): Promise<CommonResponseModel> {
    try {
      const update = await this.matAllRepo.update(
        { materialAllocationId: req.materialAllocationId },
        { status: MaterialStatusEnum.MATERIAL_ISSUED }
      );
      if (update.affected && update.affected > 0) {
        return new CommonResponseModel(true, 1, "Material Issued Sucessfully");
      } else {
        return new CommonResponseModel(false, 1, "some went wrong");
      }
    } catch (err) {
      throw err;
    }
  }

  // async updatedispatch(req?:lifeCycleStatusReq):Promise<CommonResponseModel>{
  //   console.log(req,"service");

  //   try{
  //     const update=await this. sampleRepo.update(

  //         { SampleRequestId:req.sampleReqId},
  //        {lifeCycleStatus:req.status},
  //        {DispatchedDate:req.dipatchedDate}
  //     );

  //   if(update.affected && update.affected >0 ){
  //     return new CommonResponseModel(true, 1, 'Lifecyclestatus updated Sucessfully');

  //   }else{
  //     return new CommonResponseModel(false, 1, 'some went wrong');

  //   }
  //     } catch (err) {
  //       throw err;
  //     }
  // }
  async updatedispatch(req?: lifeCycleStatusReq): Promise<CommonResponseModel> {
    try {
      const update = await this.sampleRepo.update(
        { SampleRequestId: req.sampleReqId },
        {
          lifeCycleStatus: req.status,
          DispatchedDate: req.dipatchedDate,
        }
      );

      if (update.affected && update.affected > 0) {
        return new CommonResponseModel(
          true,
          1,
          "Lifecycle status updated successfully"
        );
      } else {
        return new CommonResponseModel(false, 1, "Something went wrong");
      }
    } catch (err) {
      throw err;
    }
  }

  async getSampleOrderDetails(
    req: SampleIdRequest
  ): Promise<CommonResponseModel> {
    const sizeDta = `SELECT  GROUP_CONCAT(DISTINCT  CONCAT('sum(IF(s.size_id = ''',size_id,''', s.quantity, 0)) AS ',sizes)) AS size_name FROM size s WHERE sizes != '' 
      AND size_id IN(SELECT DISTINCT size_id FROM sample_request_size_info WHERE sample_request_id=${req.sampleRequestId}) ORDER BY  sizes`;
    const res = await this.dataSource.query(sizeDta);
    const sizesStr = res[0].size_name;
    // console.log(sizesStr, 'kkkkk')

    // console.log(req, 'rehhhh')
    const sampleDataQry = `SELECT s.colour_id AS colorId,sr.style_id AS sizeId, sty.style,cl.colour,${sizesStr} FROM sample_request_size_info s 
      left join sample_request sr on sr.sample_request_id = s.sample_request_id
      left join colour cl on cl.colour_id = s.colour_id
      left join style sty on sty.style_id = sr.style_id
      WHERE s.sample_request_id=${req.sampleRequestId} GROUP BY s.colour_id`;
    const finalres = await this.dataSource.query(sampleDataQry);
    if (finalres.length > 0) {
      return new CommonResponseModel(true, 1, "data retrived", finalres);
    } else {
      return new CommonResponseModel(false, 0, "No data");
    }
  }

  async getfabricDetailsOfSample(
    req: sampleReqIdReq
  ): Promise<CommonResponseModel> {
    try {
      const manager = this.dataSource;
      const query =
        "  SELECT mi.shade_no as shadeNo,fc.colour_id AS colourId, fc.colour AS colorName,srf.fabric_code as m3FabricCode, srf.colour_id as garColourId,c.colour as garColorName,request_no AS sampleReqNo, item_code AS itemCode,mi.description as description,fabric_info_id AS samplereFabId,(sb.required_quantity - sb.received_quantity) AS sampleQuantity,srf.sample_request_id AS sampleReqId,srf.uom_id,u.uom,sr.style_id as style,mi.hsn_code AS hsnCode FROM sample_request_fabric_info srf LEFT JOIN sample_request sr ON sr.sample_request_id=srf.sample_request_id LEFT JOIN sampling_bom sb on sb.sample_request_id = srf.sample_request_id and sb.m3_item_id = srf.fabric_code and sb.colour_id = srf.colour_id LEFT JOIN m3_items mi ON mi.m3_items_Id =srf.fabric_code left join colour c on c.colour_id=srf.colour_id left join colour fc on fc.colour_id=srf.fab_colour_id left join uom u on u.id = srf.uom_id  where srf.sample_request_id in (" +
        req.sampleReqId +
        ") and srf.fabric_info_id in (" +
        req.sampleItemId +
        ")";
      const rmData = await manager.query(query);
      if (rmData) {
        return new CommonResponseModel(true, 1, "data", rmData);
      } else {
        return new CommonResponseModel(false, 0, "no data", []);
      }
    } catch (err) {
      throw err;
    }
  }

  async getTrimDetailsOfSample(
    req: sampleReqIdReq
  ): Promise<CommonResponseModel> {
    try {
      const manager = this.dataSource;
      const query =
        "SELECT t.trim_code as m3TrimCode,mt.trim_code AS m3TrimCodeName,t.trim_type AS trimTupe,request_no AS sampleReqNo,trim_info_id AS sampleTrimInfoId,mt.uom_id AS uomId,u.uom as uomName,(sb.required_quantity - sb.received_quantity) AS sampleOrderQuantity,t.sample_request_id AS sampleReqId,tpm.structure, tpm.category, tpm.content, tpm.type, tpm.finish, tpm.hole, tpm.quality, tpm.thickness, tpm.variety, tpm.uom, tpm.color, tpm.logo, tpm.part,sr.style_id AS styleId FROM sample_request_trim_info t LEFT JOIN sample_request sr ON sr.sample_request_id=t.sample_request_id LEFT JOIN m3_trims mt ON mt.m3_trim_Id=t.trim_code left join uom u on u.id = mt.uom_id LEFT JOIN sampling_bom sb on sb.sample_request_id = t.sample_request_id and m3_item_id = t.trim_code LEFT JOIN trim_params_mapping tpm ON tpm.trim_mapping_id = mt.trim_mapping_id where t.sample_request_id in (" +
        req.sampleReqId +
        ") and t.trim_info_id in(" +
        req.sampleItemId +
        ")";
      const rmData = await manager.query(query);
      if (rmData.length > 0) {
        const modifiedRes = rmData.map((item) => {
          const trueValues = Object.keys(item)
            .filter(
              (key) =>
                [
                  "structure",
                  "category",
                  "content",
                  "type",
                  "finish",
                  "hole",
                  "quality",
                  "thickness",
                  "variety",
                  "uom",
                  "color",
                  "logo",
                  "part",
                ].includes(key) && item[key] === 1
            )
            .map((key) => key.toUpperCase());

          const concatenatedValues = trueValues.join("/");
          const label =
            trueValues.length > 0 ? "BUYER/TRIM TYPE/TRIM CATEGORY/" : "";

          const trimParams = label + concatenatedValues;
          return { ...item, trimParams };
        });

        return new CommonResponseModel(
          true,
          1,
          "Stock retrieved successfully",
          modifiedRes
        );
      } else {
        return new CommonResponseModel(false, 0, "no data", []);
      }
    } catch (err) {
      throw err;
    }
  }

  async getAllocatedBomInfo(req?: RequestNoReq): Promise<CommonResponseModel> {
    // console.log(req)
    let checkStatus;
    if (req.action == "Issued") {
      checkStatus = LifeCycleStatusEnum.READY_FOR_PRODUCTION;
    }
    if (req.action == "Approval") {
      checkStatus = LifeCycleStatusEnum.MATERIAL_ALLOCATED;
    }
    if (req.action == "receive") {
      checkStatus = LifeCycleStatusEnum.MATERIAL_ISSUED;
    }
    let fabricInfoQry = `SELECT sr.request_no as requestNo,sr.style_id as styleId,sr.brand_id as brandId,sr.buyer_id as buyerId,br.brand_name as brandName,b.buyer_name as buyerName,s.style,c.colour,mi.item_code as itemCode,sf.consumption
      ,sf.total_requirement as BOM ,sf.sample_request_id as sampleRequestId , sf.fabric_info_id as sampleReqItemId,'Fabric' as type, sf.is_stock_received AS stockRecived
       FROM sample_request sr 
            LEFT JOIN sample_request_fabric_info sf ON sf.sample_request_id = sr.sample_request_id
            LEFT JOIN buyers b ON b.buyer_id = sr.buyer_id
            LEFT JOIN style s ON s.style_id = sr.style_id
            LEFT JOIN brands br ON br.brand_id = sr.brand_id
            LEFT JOIN m3_items mi ON mi.m3_items_Id = sf.fabric_code
            LEFT JOIN colour c ON c.colour_id = sf.colour_id
            WHERE sr.life_cycle_status = '${checkStatus}'`;
    if (req.requestNo) {
      fabricInfoQry += " AND sr.sample_request_id = " + req.requestNo;
    }
    const fabricInfo = await this.dataSource.query(fabricInfoQry);
    // console.log()
    // if(req.requestNo) {

    // }
    let trimInfoQry = `SELECT sr.request_no as requestNo,sr.style_id as styleId,sr.brand_id as brandId,sr.buyer_id as buyerId,br.brand_name as brandName,b.buyer_name as buyerName,s.style,mi.trim_code as itemCode,st.consumption ,st.total_requirement as BOM, st.trim_info_id as sampleReqItemId , st.sample_request_id as sampleRequestId ,'Trim' as type, st.is_stock_received AS stockRecived
      FROM sample_request sr 
LEFT JOIN sample_request_trim_info st ON st.sample_request_id = sr.sample_request_id
      LEFT JOIN buyers b ON b.buyer_id = sr.buyer_id
            LEFT JOIN style s ON s.style_id = sr.style_id
            LEFT JOIN brands br ON br.brand_id = sr.brand_id
            LEFT JOIN m3_trims mi ON mi.m3_trim_Id = st.trim_code
      WHERE sr.life_cycle_status = '${checkStatus}'`;
    if (req.requestNo > 0) {
      trimInfoQry += " AND sr.sample_request_id = " + req.requestNo;
    }
    const trimInfo = await this.dataSource.query(trimInfoQry);

    const combineData = [...fabricInfo, ...trimInfo];
    let allocatedSampleReqInfo = {
      fabricInfo: [],
      trimInfo: [],
    };
    if (fabricInfo.length > 0) {
      allocatedSampleReqInfo.fabricInfo = fabricInfo;
    }
    if (trimInfo.length > 0) {
      allocatedSampleReqInfo.trimInfo = trimInfo;
    }
    if (fabricInfo.length > 0) {
      return new CommonResponseModel(true, 1, "data retreived", combineData);
    } else {
      return new CommonResponseModel(false, 0, "No data");
    }
  }

  async allocatedLocationInfo(req: AllocatedLocationRequest) {
    let checkStatus;
    let itemType;
    if (req.action == "Issued") {
      checkStatus = MaterialStatusEnum.READY_FOR_PRODUCTION;
    }
    if (req.action == "Approval") {
      checkStatus = MaterialStatusEnum.MATERIAL_ALLOCATED;
    }
    if (req.action == "Receive") {
      checkStatus = MaterialStatusEnum.MATERIAL_ISSUED;
    }

    let data;
    data = `SELECT ma.sample_item_id AS sampleItemId,rp.rack_position_name AS location,position_Id AS id,item_type AS itemType,mai.quantity
      ,mai.allocate_quantity AS allocatedQty,mai.material_allocation_items_id as materialAllocationId  FROM material_allocation ma
      LEFT JOIN material_allocation_items mai ON mai.material_allocation_id = ma.material_allocation_id
      LEFT JOIN rack_position rp ON rp.position_Id = mai.location_id
       WHERE sample_item_id = ${req.sampleRequestItemId} `;
    if (req.action != "Issued") {
      data += ` and ma.status = '${checkStatus}'`;
    }
    if (req.type == "Fabric") {
      data += ` and item_type = '${req.type}'`;
    } else {
      data += ` and item_type != 'Fabric'`;
    }
    const res = await this.dataSource.query(data);
    if (res.length > 0) {
      return new CommonResponseModel(true, 1, "data", res);
    } else {
      return new CommonResponseModel(false, 0, "No data Found");
    }
  }

  async updateStockStatus(
    req: AllocationApprovalRequest
  ): Promise<CommonResponseModel> {
    // console.log(req);
    const manager = new GenericTransactionManager(this.dataSource);
    let fabricStockUpdate;
    let trimStockUpdate;
    try {
      await manager.startTransaction();
      if (req.action === "Fabric") {
        fabricStockUpdate = await manager
          .getRepository(SampleReqFabricinfoEntity)
          .update(
            { fabricInfoId: req.sampleRequestItemId },
            { isStockReceived: true }
          );
      } else if (req.action === "Trim") {
        trimStockUpdate = await manager
          .getRepository(SampleRequestTriminfoEntity)
          .update(
            { trimInfoId: req.sampleRequestItemId },
            { isStockReceived: true }
          );
      }
      // console.log("************************************")
      // console.log(fabricStockUpdate)
      // console.log(trimStockUpdate)
      // console.log(fabricStockUpdate?.affected)
      // console.log(trimStockUpdate?.affected)

      if (
        fabricStockUpdate?.affected === 1 ||
        trimStockUpdate?.affected === 1
      ) {
        // console.log("hhhh")
        if (req.updateStatus) {
          // console.log("jjjjjjjjjjj")
          let response = await this.approveAllocatedStock({
            sampleRequestId: req.sampleRequestId,
            sampleRequestItemId: req.sampleRequestItemId,
            action: "Receive",
            updateStatus: true,
          });
          if (response.status) {
            // const query=`SELECT ma.status,sr.request_no AS requestNo,ma.item_type AS itemType,ma.created_at as createdAt,ma.updated_at as updatedAt
            // FROM material_allocation ma
            // LEFT JOIN  sample_request sr ON sr.sample_request_id= ma.sample_order_id
            // where sr.sample_request_id =${req.sampleRequestId}`
            // const result = await this.dataSource.query(query)
            // if(result.length>0){
            //   const sampleReqNo=response[0].requestNo
            //   const itemType=response[0].itemType
            //   const formattedDateTime = response[0].updatedAt.split(".")[0];

            //   // const create=response[0].updatedAt

            //   try{
            //     return new CommonResponseModel(true, 0, 'success', [])
            //   }catch (err){

            //   }

            // }
            await manager.completeTransaction();
            return new CommonResponseModel(true, 1, "Successfully Received");
          } else {
            await manager.releaseTransaction();
            return new CommonResponseModel(false, 0, "something went wrong");
          }
        } else {
          await manager.completeTransaction();
          return new CommonResponseModel(true, 1, "Successfully Received");
        }
      }
      // else if(trimStockUpdate?.affected === 1){
      //   console.log("hhhh")
      //   if(req.updateStatus){
      //     console.log("jjjjjjjjjjj")
      //     let response = await this.approveAllocatedStock({sampleRequestId:req.sampleRequestId,sampleRequestItemId:req.sampleRequestItemId,action:"Receive",updateStatus:true});
      //     if(response.status){
      //       await manager.completeTransaction()
      //       return new CommonResponseModel(true, 1, 'Successfully Received');
      //     }
      //     else{
      //       await manager.releaseTransaction()
      //       return new CommonResponseModel(false, 0, 'something went wrong')
      //     }
      //   }
      //   else{
      //     console.log("hhhh0000")
      //     await manager.completeTransaction()
      //     return new CommonResponseModel(true, 1, 'Successfully Received');
      //   }
      // }
      else {
        // console.log("1111111111111")
        await manager.releaseTransaction();
        return new CommonResponseModel(false, 0, "something went wrong");
      }
    } catch (err) {
      // console.log(err);
      await manager.releaseTransaction();
      return new CommonResponseModel(false, 0, err);
    }
  }

  async approveAllocatedStock(
    req: AllocationApprovalRequest
  ): Promise<CommonResponseModel> {
    // console.log(req)
    const manager = new GenericTransactionManager(this.dataSource);
    try {
      let sampleUpdateStatus;
      let sampleMaterialStatus;
      await manager.startTransaction();
      if (req.action == "Issued") {
        sampleUpdateStatus = LifeCycleStatusEnum.MATERIAL_ISSUED;
        sampleMaterialStatus = MaterialStatusEnum.MATERIAL_ISSUED;
      }
      if (req.action == "Approval") {
        sampleUpdateStatus = LifeCycleStatusEnum.READY_FOR_PRODUCTION;
        sampleMaterialStatus = MaterialStatusEnum.READY_FOR_PRODUCTION;
      }
      if (req.action == "Receive") {
        sampleUpdateStatus = LifeCycleStatusEnum.MATERIAL_RECEIVED;
        sampleMaterialStatus = MaterialStatusEnum.MATERIAL_RECEIVED;
      }
      const updateSamleReq = await manager
        .getRepository(SampleRequest)
        .update(
          { SampleRequestId: req.sampleRequestId },
          { lifeCycleStatus: sampleUpdateStatus }
        );
      if (updateSamleReq.affected) {
        const updateAllocations = await manager
          .getRepository(MaterialAllocationEntity)
          .update(
            { sampleOrderId: req.sampleRequestId },
            { status: sampleMaterialStatus }
          );
        // console.log(updateAllocations);
        if (updateAllocations.affected) {
          const query = `SELECT ma.status,sr.request_no AS requestNo,ma.item_type AS itemType,ma.created_at AS createdAt,ma.updated_at as updatedAt,po.created_user AS createdUser,IF(po.po_against = "Sample Order", 
       IF(po.po_material_type = "Fabric", sr.request_no, srt.request_no),
       IF(po.po_material_type = "Fabric", fi.request_no, ti.request_no)
    ) AS indentNo
          FROM material_allocation ma
	  LEFT JOIN  sample_request sr ON sr.sample_request_id= ma.sample_order_id
	LEFT JOIN material_allocation_items mai ON mai.material_allocation_id =ma.material_allocation_id
	LEFT JOIN stocks s ON s.id=mai.stock_id
	LEFT JOIN grn_items gi ON gi.grn_item_id
	LEFT JOIN purchase_order po ON po.purchase_order_id=gi.po_id
	LEFT JOIN 
    purchae_order_items poi ON poi.purchase_order_id = po.purchase_order_id 
	LEFT JOIN indent_fabric itf ON itf.ifabric_id = poi.indent_item_id AND poi.item_type = "FABRIC" 
LEFT JOIN  indent_trims itt ON itt.itrims_id = poi.indent_item_id AND poi.item_type != "FABRIC" 
LEFT JOIN indent ti ON ti.indent_id = itt.indent_id 
LEFT JOIN indent fi ON fi.indent_id = itf.indent_id
    LEFT JOIN sample_request_fabric_info spf ON spf.fabric_info_id = poi.sample_item_id AND po.po_material_type = "Fabric" 
LEFT JOIN sample_request_trim_info spt ON spt.trim_info_id = poi.sample_item_id AND po.po_material_type = "Trim"
LEFT JOIN sample_request srt ON srt.sample_request_id = spt.sample_request_id 
	
            where sr.sample_request_id =${req.sampleRequestId}`;
          const response = await this.dataSource.query(query);
          // console.log(response,"pppppppp");

          // console.log('yess')
          await manager.completeTransaction();
          return new CommonResponseModel(
            true,
            1,
            req.action == "Issued"
              ? "Successfully Issued"
              : req.action == "Receive"
              ? "Successfully Received"
              : "Successfully Approved"
          );
        } else {
          await manager.releaseTransaction();
          return new CommonResponseModel(false, 0, "something went wrong");
        }
      } else {
        await manager.releaseTransaction();
        return new CommonResponseModel(false, 0, "something went wrong");
      }
    } catch (err) {
      console.log(err, "erorrrrr");

      await manager.releaseTransaction();
      return new CommonResponseModel(false, 0, err);
    }
  }

  async issueMaterial(req: MaterialIssueRequest): Promise<CommonResponseModel> {
    const manager = new GenericTransactionManager(this.dataSource);
    try {
      const grnInfo = `select grn_id,grn_type,item_type from grn where grn_id in(select grn_id from grn_items where grn_item_no = '${req.GRNItemNumber}')`;
      const grnRes = await this.dataSource.query(grnInfo);
      // console.log(grnRes)
      await manager.startTransaction();
      if (grnRes.length > 0) {
        let grnItemInfo = `select sample_item_id as sampleItemId,indent_item_id as indentItemId,sample_req_id as sampleReqId,m3_item_code_id as m3ItemId from grn_items where grn_item_no = '${req.GRNItemNumber}'`;
        if (grnRes[0].grn_type === "SAMPLE_ORDER") {
          grnItemInfo =
            grnItemInfo + ` and sample_req_id = ${req.sampleRequestId}`;
        }
        const grnItemRes = await this.dataSource.query(grnItemInfo);

        // console.log("grnItemRes");
        // console.log(grnItemRes);

        // let sampleItemId
        // if(grnItemRes[0].sampleItemId > 0){
        //   sampleItemId = grnItemRes[0].sampleItemId
        // }
        // if(grnItemRes[0].indentItemId > 0){
        //   sampleItemId = grnItemRes[0].indentItemId
        // }
        const updateAllocations = await manager
          .getRepository(MaterialAllocationEntity)
          .update(
            {
              sampleOrderId: req.sampleRequestId,
              m3ItemId: grnItemRes[0].m3ItemId,
            },
            { status: MaterialStatusEnum.MATERIAL_ISSUED }
          );
        if (updateAllocations.affected) {
          const checkAllIssuedOrNot = await manager
            .getRepository(MaterialAllocationEntity)
            .find({
              where: {
                sampleOrderId: req.sampleRequestId,
                status: Not(MaterialStatusEnum.MATERIAL_ISSUED),
              },
            });
          // console.log('resddd', checkAllIssuedOrNot)
          if (checkAllIssuedOrNot.length == 0) {
            const updateSamleReq = await manager
              .getRepository(SampleRequest)
              .update(
                { SampleRequestId: req.sampleRequestId },
                { lifeCycleStatus: LifeCycleStatusEnum.MATERIAL_ISSUED }
              );
            if (updateSamleReq.affected) {
              //location Status update
              const allocatedLocationsQry = `SELECT SUM(quantity) AS stock,st.location_id as location FROM stocks st WHERE location_id IN(
                  SELECT location_id FROM material_allocation_items WHERE material_allocation_id IN(SELECT material_allocation_id FROM material_allocation
                  WHERE sample_order_id = ${req.sampleRequestId})) GROUP BY st.location_id`;
              const locationsRes = await this.dataSource.query(
                allocatedLocationsQry
              );
              for (const rec of locationsRes) {
                if (rec.stock == 0) {
                  const updateLocation = await manager
                    .getRepository(RackPositionEntity)
                    .update(
                      { positionId: rec.location },
                      { status: RackPositionStatusEnum.NOTOCCUPIED }
                    );
                  if (updateLocation.affected) {
                    await manager.completeTransaction();
                    return new CommonResponseModel(
                      true,
                      1,
                      "Material Issued successfully"
                    );
                  } else {
                    await manager.completeTransaction();
                    return new CommonResponseModel(
                      true,
                      1,
                      "Something went wrong in location update"
                    );
                  }
                } else {
                  await manager.completeTransaction();
                  return new CommonResponseModel(
                    true,
                    1,
                    "Material Issued successfully"
                  );
                }
              }
            } else {
              await manager.releaseTransaction();
              return new CommonResponseModel(false, 0, "Something went wrong");
            }
          } else {
            await manager.completeTransaction();
            return new CommonResponseModel(
              true,
              1,
              "Material Issued successfully"
            );
          }
        } else {
          await manager.releaseTransaction();
          return new CommonResponseModel(false, 0, "Something went wrong");
        }
        // let concatstr
        // if(grnRes[0].grn_type == GRNTypeEnum.SAMPLE_ORDER){
        //     if(grnRes[0].item_type == ItemTypeEnum.FABRIC){
        //       concatstr = ` left join sample_request_fabric_info sf on si.fabric_info_id = gi.sample_item_id`
        //     }else{
        //       concatstr = ` left join sample_request_trim_info sf on si.trim_info_id = gi.sample_item_id`
        //     }
        // }else {
        //     if(grnRes[0].item_type == ItemTypeEnum.FABRIC){
        //       concatstr = ` left join indent_fabric ii on ii.ifabric_id = gi.sample_item_id`
        //     }
        // }
      } else {
        await manager.releaseTransaction();
        return new CommonResponseModel(false, 0, "Invalid Roll Barcode");
      }
    } catch (err) {
      await manager.releaseTransaction();
      return new CommonResponseModel(false, 0, err);
    }
    // const grnItemData = `select * from grn_items gi where grn_item_no = ${req.GRNItemNumber} `

    return;
  }

  async getGrnRollsForSampleOrder(
    req: SampleOrderIdRequest
  ): Promise<CommonResponseModel> {
    const grnInfoQry = `SELECT gi.grn_item_no as rollBarcode FROM material_allocation_items mai 
          LEFT JOIN stocks st ON st.id = mai.stock_id
          LEFT JOIN grn_items gi ON gi.grn_item_id = st.grn_item_id
          WHERE material_allocation_id IN
          (SELECT material_allocation_id FROM material_allocation WHERE sample_order_id = ${req.sampleRequestId} and status = '${MaterialStatusEnum.READY_FOR_PRODUCTION}') group by gi.grn_item_no`;
    const res = await this.dataSource.query(grnInfoQry);
    if (grnInfoQry.length > 0) {
      return new CommonResponseModel(true, 1, "data retreived", res);
    } else {
      return new CommonResponseModel(false, 0, "No data found");
    }
  }

  async getmaterialissue(req?: RequestNoReq): Promise<CommonResponseModel> {
    try {
      const fabricInfoQry = `
          SELECT 
            sr.request_no AS requestNo,
            sr.sample_request_id ,
            rp.rack_position_name AS location,position_Id AS id,
            sr.life_cycle_status AS STATUS,
            sr.remarks,
            sr.description,
            sr.cost_ref,
            sr.contact,
            sr.expected_delivery_date,
            sr.user,
            sr.conversion,
            s.style,
            sf.fabric_code,
            sf.total_requirement,
            br.brand_name AS brandName,
            b.buyer_name AS buyerName,
            c.colour,
            b.buyer_code,
            sf.consumption,
            ma.item_type As itemType,
            mai.allocate_quantity,
            pr.profit_control_head,
            l.location_name AS location,
            mi.item_code AS itemCode,
            sf.fabric_info_id as sampleFabricId
            FROM sample_request sr 
            LEFT JOIN buyers b ON b.buyer_id = sr.buyer_id
            LEFT JOIN style s ON s.style_id = sr.style_id
            LEFT JOIN profit_control_head pr ON pr.profit_control_head_id = sr.profit_control_head_id
            LEFT JOIN brands br ON br.brand_id = sr.brand_id
            LEFT JOIN sample_request_fabric_info sf ON sf.sample_request_id = sr.sample_request_id
            LEFT JOIN material_allocation ma ON ma.sample_item_id = sf.fabric_info_id
            LEFT JOIN sample_request_trim_info st ON st.sample_request_id = sr.sample_request_id
            LEFT JOIN material_allocation_items mai ON mai.material_allocation_id = ma.material_allocation_id
            LEFT JOIN m3_items mi ON mi.m3_items_Id = sf.fabric_code
            LEFT JOIN colour c ON c.colour_id = sf.colour_id
            LEFT JOIN location l ON l.location_id = mai.location_id
            LEFT JOIN rack_position rp ON rp.position_Id = mai.location_id

          WHERE ma.item_type = 'fabric' AND sr.life_cycle_status = 'MATERIAL_ISSUED' 
          ${req?.requestNo ? `AND sr.request_no = ${req.requestNo}` : ""}
          GROUP BY sr.request_no, sr.sample_request_id`;
      const fabricInfo = await this.dataSource.query(fabricInfoQry);
      // const trimInfo = await this.dataSource.query(trimInfoQry);

      const combineData = [...fabricInfo];

      if (combineData.length > 0) {
        return new CommonResponseModel(true, 1, "Data retrieved", combineData);
      } else {
        return new CommonResponseModel(false, 0, "No data");
      }
    } catch (error) {
      console.error("Error in getmaterialissue:", error);
      return new CommonResponseModel(false, 0, "Error fetching data");
    }
  }

  // async getmaterialissue(req?: RequestNoReq): Promise<CommonResponseModel> {
  //   try {
  //     const combinedInfoQry = `
  //       SELECT
  //         sr.request_no AS requestNo,
  //         sr.sample_request_id ,
  //         rp.rack_position_name AS location,position_Id AS id,
  //         sr.life_cycle_status AS STATUS,
  //         sr.remarks,
  //         sr.description,
  //         sr.cost_ref,
  //         sr.contact,
  //         sr.expected_delivery_date,
  //         sr.user,
  //         sr.conversion,
  //         s.style,
  //         sf.fabric_code,
  //         sf.total_requirement,
  //         br.brand_name AS brandName,
  //         b.buyer_name AS buyerName,
  //         c.colour,
  //         b.buyer_code,
  //         sf.consumption,
  //         ma.item_type As itemType,
  //         mai.allocate_quantity,
  //         pr.profit_control_head,
  //         l.location_name AS location,
  //         mi.item_code AS itemCode,
  //         sf.fabric_info_id as sampleFabricId
  //       FROM sample_request sr
  //         LEFT JOIN buyers b ON b.buyer_id = sr.buyer_id
  //         LEFT JOIN style s ON s.style_id = sr.style_id
  //         LEFT JOIN profit_control_head pr ON pr.profit_control_head_id = sr.profit_control_head_id
  //         LEFT JOIN brands br ON br.brand_id = sr.brand_id
  //         LEFT JOIN sample_request_fabric_info sf ON sf.sample_request_id = sr.sample_request_id
  //         LEFT JOIN material_allocation ma ON ma.sample_item_id = sf.fabric_info_id
  //         LEFT JOIN material_allocation_items mai ON mai.material_allocation_id = ma.material_allocation_id
  //         LEFT JOIN m3_items mi ON mi.m3_items_Id = sf.fabric_code
  //         LEFT JOIN colour c ON c.colour_id = sf.colour_id
  //         LEFT JOIN location l ON l.location_id = mai.location_id
  //         LEFT JOIN rack_position rp ON rp.position_Id = mai.location_id
  //       WHERE ma.item_type = 'fabric' AND sr.life_cycle_status = 'MATERIAL_ISSUED'
  //         ${req?.requestNo ? `AND sr.request_no = ${req.requestNo}` : ''}
  //       GROUP BY sr.request_no, sr.sample_request_id

  //       UNION

  //       SELECT
  //         sr.request_no AS requestNo,
  //         sr.sample_request_id ,
  //         rp.rack_position_name AS location,position_Id AS id,
  //         sr.life_cycle_status AS STATUS,
  //         sr.remarks,
  //         sr.description,
  //         sr.cost_ref,
  //         sr.contact,
  //         sr.expected_delivery_date,
  //         sr.user,
  //         sr.conversion,
  //         s.style,
  //         st.trim_code,
  //         br.brand_name AS brandName,
  //         b.buyer_name AS buyerName,
  //         c.colour,
  //         b.buyer_code,
  //         st.consumption,
  //         ma.item_type AS itemType,
  //         mai.allocate_quantity,
  //         pr.profit_control_head,
  //         l.location_name AS location,
  //         mi.trim_code as itemCode,
  //         st.trim_info_id as sampleTrimInfoId
  //       FROM sample_request sr
  //         LEFT JOIN profit_control_head pr ON pr.profit_control_head_id = sr.profit_control_head_id
  //         LEFT JOIN buyers b ON b.buyer_id = sr.buyer_id
  //         LEFT JOIN style s ON s.style_id = sr.style_id
  //         LEFT JOIN sample_request_fabric_info sf ON sf.sample_request_id = sr.sample_request_id
  //         LEFT JOIN brands br ON br.brand_id = sr.brand_id
  //         LEFT JOIN colour c ON c.colour_id = sf.colour_id
  //         LEFT JOIN sample_request_trim_info st ON st.sample_request_id = sr.sample_request_id
  //         LEFT JOIN material_allocation ma ON ma.sample_item_id = st.trim_info_id
  //         LEFT JOIN material_allocation_items mai ON mai.material_allocation_id = ma.material_allocation_id
  //         LEFT JOIN m3_trims mi ON mi.m3_trim_Id = st.trim_code
  //         LEFT JOIN location l ON l.location_id = mai.location_id
  //         LEFT JOIN rack_position rp ON rp.position_Id = mai.location_id
  //       WHERE ma.item_type != 'fabric' AND sr.life_cycle_status = 'MATERIAL_ISSUED'
  //         ${req?.requestNo ? `AND sr.request_no = ${req.requestNo}` : ''}
  //       GROUP BY l.location_name, sr.request_no, sr.sample_request_id`;

  //     const combinedInfo = await this.dataSource.query(combinedInfoQry);

  //     if (combinedInfo.length > 0) {
  //       return new CommonResponseModel(true, 1, 'Data retrieved', combinedInfo);
  //     } else {
  //       return new CommonResponseModel(false, 0, 'No data');
  //     }
  //   } catch (error) {
  //     console.error('Error in getmaterialissue:', error);
  //     return new CommonResponseModel(false, 0, 'Error fetching data');
  //   }
  // }

  async getRequestNo(req?: RequestNoReq): Promise<CommonResponseModel> {
    const records = await this.sampleRepo.find({
      where: {
        lifeCycleStatus: LifeCycleStatusEnum.MATERIAL_ISSUED,
        samplingUser: req.userId,
      },
    });
    if (records.length)
      return new CommonResponseModel(
        true,
        65441,
        "Data Retrieved Successfully",
        records
      );
    else return new CommonResponseModel(false, 0, "No data found");
  }

  async allocatedLocation(req: AllLocationRequest) {
    // let checkStatus
    // if(req.action == 'Issued'){
    //   checkStatus = MaterialStatusEnum.READY_FOR_PRODUCTION
    // }
    // if(req.action == 'Approval'){
    //   checkStatus = MaterialStatusEnum.MATERIAL_ALLOCATED
    // }
    // console.log('Sample Request Item ID:', req.sampleRequestItemId);

    const data = `SELECT ma.sample_item_id AS sampleItemId,rp.rack_position_name AS location,position_Id AS id,item_type AS itemType,mai.quantity
    ,mai.allocate_quantity AS allocatedQty,mai.material_allocation_items_id as materialAllocationId  FROM material_allocation ma
    LEFT JOIN material_allocation_items mai ON mai.material_allocation_id = ma.material_allocation_id
    LEFT JOIN rack_position rp ON rp.position_Id = mai.location_id
    `;
    const res = await this.dataSource.query(data);
    if (res.length > 0) {
      return new CommonResponseModel(true, 1, "data", res);
    } else {
      return new CommonResponseModel(false, 0, "No data Found");
    }
  }
  async getbyID(req: RequestNoReq): Promise<CommonResponseModel> {
    // console.log(req, "service.....");

    try {
      const fabricInfoQry = `
        SELECT 
          sr.request_no AS requestNo,
          sr.sample_request_id AS id,
          sr.life_cycle_status AS STATUS,
          sr.remarks,
          sr.description,
          sr.cost_ref,
          sr.contact,
          sr.expected_delivery_date,
          sr.user,
          sr.conversion,
          s.style,
          sf.fabric_code,
          sf.total_requirement,
          br.brand_name AS brandName,
          b.buyer_name AS buyerName,
          c.colour,
          b.buyer_code,
          sf.consumption,
          ma.item_type As itemType,
          mai.allocate_quantity,
          pr.profit_control_head,
          l.location_name AS location,
          mi.item_code AS itemCode
        FROM sample_request sr 
          LEFT JOIN buyers b ON b.buyer_id = sr.buyer_id
          LEFT JOIN style s ON s.style_id = sr.style_id
          LEFT JOIN profit_control_head pr ON pr.profit_control_head_id = sr.profit_control_head_id
          LEFT JOIN brands br ON br.brand_id = sr.brand_id
          LEFT JOIN sample_request_fabric_info sf ON sf.sample_request_id = sr.sample_request_id
          LEFT JOIN material_allocation ma ON ma.sample_item_id = sf.fabric_info_id
          LEFT JOIN material_allocation_items mai ON mai.material_allocation_id = ma.material_allocation_id
          LEFT JOIN m3_items mi ON mi.m3_items_Id = sf.fabric_code
          LEFT JOIN colour c ON c.colour_id = sf.colour_id
          LEFT JOIN location l ON l.location_id = mai.location_id
        WHERE sr.sample_request_id = ${req.sampreqId} AND 
        ma.item_type = 'fabric' AND sr.life_cycle_status = 'MATERIAL_ISSUED'
        GROUP BY sr.request_no`;

      const trimInfoQry = `
        SELECT 
          sr.request_no AS requestNo,
          sr.sample_request_id AS id,
          sr.life_cycle_status AS STATUS,
          sr.remarks,
          sr.description,
          sr.cost_ref,
          sr.contact,
          sr.expected_delivery_date,
          sr.user,
          sr.conversion,
          s.style,
          st.trim_code,
          br.brand_name AS brandName, 
          b.buyer_name AS buyerName,
          c.colour,
          b.buyer_code,
          st.consumption,
          ma.item_type AS itemType,
          mai.allocate_quantity,
          pr.profit_control_head,
          l.location_name AS location,
          mi.trim_code AS itemCode
        FROM sample_request sr 
          LEFT JOIN profit_control_head pr ON pr.profit_control_head_id = sr.profit_control_head_id
          LEFT JOIN buyers b ON b.buyer_id = sr.buyer_id
          LEFT JOIN style s ON s.style_id = sr.style_id
          LEFT JOIN sample_request_fabric_info sf ON sf.sample_request_id = sr.sample_request_id
          LEFT JOIN brands br ON br.brand_id = sr.brand_id
          LEFT JOIN colour c ON c.colour_id = sf.colour_id
          LEFT JOIN sample_request_trim_info st ON st.sample_request_id = sr.sample_request_id
          LEFT JOIN material_allocation ma ON ma.sample_item_id = st.trim_info_id
          LEFT JOIN material_allocation_items mai ON mai.material_allocation_id = ma.material_allocation_id
          LEFT JOIN m3_trims mi ON mi.m3_trim_Id = st.trim_code
          LEFT JOIN location l ON l.location_id = mai.location_id
        WHERE sr.sample_request_id = ${req.sampreqId} AND ma.item_type != 'fabric' AND sr.life_cycle_status = 'MATERIAL_ISSUED'
        GROUP BY l.location_name, sr.request_no`;

      // console.log('Fabric Info Query:', fabricInfoQry);
      // console.log('SQL Query:', trimInfoQry);

      const fabricInfo = await this.dataSource.query(fabricInfoQry);
      const trimInfo = await this.dataSource.query(trimInfoQry);

      const combineData = [...fabricInfo, ...trimInfo];

      if (combineData.length > 0) {
        return new CommonResponseModel(true, 1, "Data retrieved", combineData);
      } else {
        return new CommonResponseModel(false, 0, "No data");
      }
    } catch (error) {
      console.error("Error in getbyID:", error);
      return new CommonResponseModel(false, 0, "Error fetching data");
    }
  }

  async getPickListInfo(req?: requestNoReq): Promise<CommonResponseModel> {
    let fabricInfoQry = `SELECT sr.request_no AS requestNo,br.brand_name AS brandName,b.buyer_name AS buyerName,s.style,c.colour,sf.total_requirement AS consumption,ma.item_type AS itemType,mai.allocate_quantity AS allocateQty,
    l.rack_position_name AS location,mi.item_code AS itemCode
    FROM sample_request sr 
     LEFT JOIN buyers b ON b.buyer_id = sr.buyer_id
     LEFT JOIN style s ON s.style_id = sr.style_id
     LEFT JOIN brands br ON br.brand_id = sr.brand_id
     LEFT JOIN sample_request_fabric_info sf ON sf.sample_request_id = sr.sample_request_id
     LEFT JOIN material_allocation ma ON ma.sample_item_id = sf.fabric_info_id
     LEFT JOIN material_allocation_items mai ON mai.material_allocation_id = ma.material_allocation_id
     LEFT JOIN m3_items mi ON mi.m3_items_Id = ma.m3_item_id
     LEFT JOIN colour c ON c.colour_id = sf.colour_id
     LEFT JOIN rack_position l ON l.position_Id = mai.location_id
    WHERE  sr.sample_request_id= '${req.requestNo}' AND ma.item_type = 'FABRIC'
    order by mi.item_code`;

    const fabricInfo = await this.dataSource.query(fabricInfoQry);
    let trimInfoQry = `SELECT sr.request_no AS requestNo,
      br.brand_name AS brandName,
b.buyer_name AS buyerName,
s.style,
ma.item_type AS itemType,
st.total_requirement AS consumption,
mai.allocate_quantity AS allocateQty,
l.rack_position_name AS location,
mi.trim_code AS itemCode
FROM sample_request sr 
 LEFT JOIN buyers b ON b.buyer_id = sr.buyer_id
 LEFT JOIN style s ON s.style_id = sr.style_id
 LEFT JOIN brands br ON br.brand_id = sr.brand_id
 LEFT JOIN sample_request_trim_info st ON st.sample_request_id = sr.sample_request_id
 LEFT JOIN material_allocation ma ON ma.sample_item_id = st.trim_info_id
 LEFT JOIN material_allocation_items mai ON mai.material_allocation_id = ma.material_allocation_id
 LEFT JOIN m3_trims mi ON mi.m3_trim_Id = ma.m3_item_id
 LEFT JOIN rack_position l ON l.position_Id = mai.location_id
WHERE  sr.sample_request_id= '${req.requestNo}' AND  ma.item_type != 'FABRIC'
order by mi.trim_code`;

    const trimInfo = await this.dataSource.query(trimInfoQry);

    const combineData = [...fabricInfo, ...trimInfo];
    return new CommonResponseModel(true, 1, "data retreived", combineData);

    // let allocatedSampleReqInfo = {
    //   fabricInfo:[],
    //   trimInfo:[]
    // }
    // if(fabricInfo.length > 0){
    //   allocatedSampleReqInfo.fabricInfo = fabricInfo
    // }
    // if(trimInfo.length > 0){
    //   allocatedSampleReqInfo.trimInfo = trimInfo
    // }
    // if(fabricInfo.length > 0){
    //   return new CommonResponseModel(true,1,'data retreived',combineData)
    // }else{
    //   return new CommonResponseModel(false,0,'No data')
    // }
  }

  //mobile APP API for operation reporting UI
  async getSizeWiseOrders(
    req: SampleOrderIdRequest
  ): Promise<CommonResponseModel> {
    const dataQry = `SELECT ss.quantity,sr.request_no as requestNo,c.colour,s.sizes FROM sample_request_size_info ss
  LEFT JOIN sample_request sr ON sr.sample_request_id = ss.sample_request_id
  LEFT JOIN colour c ON c.colour_id = ss.colour_id
  LEFT JOIN size s ON s.size_id = ss.size_id where ss.sample_request_id = ${req.sampleRequestId}`;
    const data = await this.dataSource.query(dataQry);
    if (dataQry.length > 0) {
      return new CommonResponseModel(true, 1, "data retreived", data);
    } else {
      return new CommonResponseModel(false, 0, "No data");
    }
  }

  //Mobile App API for sizes dropdown for operation reporting for sample request

  async getOrderedSizes(
    req: SampleOrderSizesRequest
  ): Promise<CommonResponseModel> {
    const sizesDataQry = `select distinct(ss.size_id) as sizeId,s.sizes as size from sample_request_size_info ss left join size s on s.size_id = ss.size_id where sample_request_id = ${req.sampleRequestId} and ss.colour_id = ${req.colorId}`;
    const sizesData = await this.dataSource.query(sizesDataQry);
    if (sizesData.length > 0) {
      return new CommonResponseModel(true, 1, "data retrieved", sizesData);
    } else {
      return new CommonResponseModel(false, 0, "NO data");
    }
  }

  //Mobile App API for Colors dropdown for operation reporting for sample request

  async getOrderedColors(
    req: SampleOrderIdRequest
  ): Promise<CommonResponseModel> {
    const colorsDataQry = `select distinct(ss.colour_id) as colorId,c.colour as colour from sample_request_size_info ss left join colour c on c.colour_id = ss.colour_id where sample_request_id = ${req.sampleRequestId}`;
    const colorsData = await this.dataSource.query(colorsDataQry);
    if (colorsData.length > 0) {
      return new CommonResponseModel(true, 1, "data retrieved", colorsData);
    } else {
      return new CommonResponseModel(false, 0, "NO data");
    }
  }

  //Mobile App API to get quantity for a colour and size operation reporting for sample request

  async getQuantityForSIzeAndColor(
    req: OrderQuantityRequset
  ): Promise<CommonResponseModel> {
    const sampleOrderDataQry = `select sample_req_size_id as SampleOrderInfoId,quantity from sample_request_size_info where sample_request_id = ${req.sampleRequestId} and colour_id = ${req.colourId} and size_id = ${req.sizeId}`;
    const sampleOrderData = await this.dataSource.query(sampleOrderDataQry);
    if (sampleOrderData.length == 1) {
      const checkOperationQry = `select sp.sequence, sp.operation AS operationId,ot.next_operation as nextOperation from operation_tracking ot left join operations op on op.operation_name = ot.next_operation left join sample_request_process_info sp on sp.sample_request_id = sample_req_id and sp.operation = op.operation_id where colour_id = ${req.colourId} and size_id = ${req.sizeId} and sample_req_id = ${req.sampleRequestId} ORDER BY operation_tracking_id DESC LIMIT 1`;
      const nextOperationInfo = await this.dataSource.query(checkOperationQry);
      let nextOperation;
      let operationId;
      let sequence;
      if (nextOperationInfo.length > 0) {
        nextOperation = nextOperationInfo[0].nextOperation;
        operationId = nextOperationInfo[0].operationId;
        sequence = nextOperationInfo[0].sequence;
      }
      const resData = {
        nextOperation: nextOperation,
        operationId: operationId,
        sequence: sequence,
        operationname: nextOperation,
        sampledata: sampleOrderData,
      };
      return new CommonResponseModel(true, 1, "data retreived", resData);
    }
    if (sampleOrderData.length > 1) {
      return new CommonResponseModel(false, 0, "Something Went wrong");
    } else {
      return new CommonResponseModel(false, 0, "No Quantity found");
    }
  }

  async getAllSampleRequestSizesInfo(
    req?: sampleReqIdReq
  ): Promise<CommonResponseModel> {
    const sizeDta = `SELECT  GROUP_CONCAT(DISTINCT  CONCAT('sum(IF(s.size_id = ''',size_id,''', s.quantity, 0)) AS ',sizes)) AS size_name FROM size s WHERE sizes != '' 
    AND size_id IN(SELECT DISTINCT size_id FROM sample_request_size_info WHERE sample_request_id=${req.sampleReqId}) ORDER BY  sizes`;
    const res = await this.dataSource.query(sizeDta);
    const sizesStr = res[0].size_name;
    // console.log(sizesStr, 'kkkkk')

    // console.log(req, 'rehhhh')
    const sampleDataQry = `SELECT cl.colour,${sizesStr} FROM sample_request_size_info s 
    left join sample_request sr on sr.sample_request_id = s.sample_request_id
    left join colour cl on cl.colour_id = s.colour_id
    WHERE s.sample_request_id=${req.sampleReqId} GROUP BY s.colour_id`;
    const finalres = await this.dataSource.query(sampleDataQry);
    if (finalres.length > 0) {
      return new CommonResponseModel(true, 1, "data retrived", finalres);
    } else {
      return new CommonResponseModel(false, 0, "No data");
    }
  }

  async getAllSampleRequestsInfo(
    req?: sampleReqIdReq
  ): Promise<CommonResponseModel> {
    try {
      const manager = this.dataSource;
      const rawQuery = `SELECT s.request_no,s.life_cycle_status,bu.buyer_name,b.brand_name,srt.trim_type,srf.fabric_code,si.sizes,c.colour,si.size_id,s.extension,s.cost_ref,s.description,s.dmm_id,s.user,pr.product,m.country_name as made_in,s.remarks as sremarks,s.file_name,srt.remarks AS trim_remarks,srf.remarks AS fab_remarks ,s.sam_value,
      st.style,pch.profit_control_head,mi.item_code as fabCode,CONCAT(mt.item_code,'-',mt.description) as trimCode,e.first_name,s.contact,s.status,srs.quantity,srf.total_requirement as fabtotal_requirement,srf.wastage as fabwastage,srf.consumption as fabconsumption,uf.uom as fabuom,srt.total_requirement as trimtotal_requirement,srt.wastage as trimwastage,srt.consumption as trimconsumption,ut.uom as trimuom,fc.colour AS fabColour ,cf.colour as garmentcolour,ca.category,ed.first_name as dmmFirst,ed.last_name as dmmLast,sty.sample_type,sst.sample_sub_type,s.category as sampleCategory,
      s.life_cycle_status AS lifeCycleStatus, s.conversion,s.expected_delivery_date,rp.rack_position_name ,s.location_id as location,t.trim_category,op.operation_name,srp.sequence, srp.remarks,st.style_file_name AS styleUrl ,srf.fabric_info_id as fabricInfoId,srt.trim_info_id as trimInfoId FROM sample_request s
      LEFT JOIN brands b ON b.brand_id = s.brand_id
      LEFT JOIN buyers bu ON bu.buyer_id = s.buyer_id
      LEFT JOIN style st ON st.style_id = s.style_id
      LEFT JOIN profit_control_head pch ON pch.profit_control_head_id =s.profit_control_head_id
      LEFT JOIN sample_request_fabric_info srf ON srf.sample_request_id = s.sample_request_id
      LEFT JOIN sample_request_trim_info srt ON srt.sample_request_id = s.sample_request_id
      LEFT JOIN sample_request_size_info srs ON srs.sample_request_id = s.sample_request_id
      LEFT JOIN sample_request_process_info srp ON srp.sample_request_id = s.sample_request_id
      LEFT JOIN operations op ON op.operation_id = srp.operation
      LEFT JOIN size si ON si.size_id = srs.size_id
      LEFT JOIN colour c ON c.colour_id = srs.colour_id
      LEFT JOIN m3_items mi ON mi.m3_items_Id = srf.fabric_code
      LEFT JOIN m3_trims mt ON mt.m3_trim_Id = srt.trim_code
      LEFT JOIN employee_details e ON e.employee_id = s.technician_id
      LEFT JOIN uom uf ON uf.id = srf.uom_id
      LEFT JOIN uom ut ON ut.id = srt.uom_id
      LEFT JOIN employee_details ed ON ed.employee_id = s.dmm_id
      LEFT JOIN colour cf ON cf.colour_id = srf.colour_id
      LEFT JOIN colour fc ON fc.colour_id = srf.fab_colour_id
      LEFT JOIN countries m ON m.country_id = s.made_in
      LEFT JOIN category ca ON ca.category_id = mt.category_id
      LEFT JOIN liscence_type lt ON lt.liscence_type_id = s.product
      LEFT JOIN product pr ON pr.product_id = s.product
      LEFT JOIN rack_position rp ON rp.position_Id = s.location_id
      LEFT JOIN sample_types sty ON sty.sample_type_id= s.sample_type_id
      LEFT JOIN sample_sub_types sst ON sst.sample_sub_type_id = s.sample_sub_type_id
      LEFT JOIN trim t ON  t.trim_id = mt.trim_category_id

      WHERE s.sample_request_id = ${req.sampleReqId}`;

      const info = await manager.query(rawQuery);
      const MapData = new Map<string, SampleRequestInfoModel>();

      let sizedata = new Map<number, SampleSizeInfoModel>();

      if (info.length > 0) {
        for (const rec of info) {
          // console.log(rec);
          if (!MapData.has(rec.requestNo)) {
            MapData.set(
              rec.requestNo,
              new SampleRequestInfoModel(
                rec.request_no,
                rec.sample_request_id,
                rec.style,
                rec.brand_name,
                rec.buyer_name,
                rec.first_name,
                rec.status,
                rec.lifeCycleStatus,
                rec.contact,
                rec.profit_control_head,
                rec.expected_delivery_date,
                rec.extension,
                rec.conversion,
                rec.dmmFirst,
                rec.product,
                rec.user,
                rec.description,
                rec.cost_ref,
                rec.type,
                rec.made_in,
                rec.sremarks,
                rec.file_name,
                rec.sam_value,
                [],
                [],
                [],
                rec.location,
                rec.sample_type,
                rec.sample_sub_type,
                rec.sampleCategory,
                rec.dmmLast,
                rec.styleUrl
              )
            );
          }

          const existingTrim = MapData.get(rec.requestNo).trimInfo.find(
            (trimInfo) => trimInfo.trimInfoId === rec.trimInfoId
          );

          if (!existingTrim) {
            MapData.get(rec.requestNo).trimInfo.push({
              trimCode: rec.trimCode,
              type: rec.trim_type,
              total: rec.trimtotal_requirement,
              consumption: rec.trimconsumption,
              wastage: rec.trimwastage,
              uom: rec.trimuom,
              category: rec.trim_category,
              remarks: rec.trim_remarks,
              trimInfoId: rec.trimInfoId,
            });
          }
          const existingProcess = MapData.get(rec.requestNo).processInfo.find(
            (p) => p.operation === rec.operation_name
          );

          if (!existingProcess) {
            MapData.get(rec.requestNo).processInfo.push({
              operation: rec.operation_name,
              sequence: rec.sequence,
              remarks: rec.remarks,
            });
          }
          const existingFabric = MapData.get(rec.requestNo).fabInfo.find(
            (fabInfo) => fabInfo.fabInfoId === rec.fabricInfoId
          );

          if (!existingFabric) {
            MapData.get(rec.requestNo).fabInfo.push({
              fabricCode: rec.fabCode,
              total: rec.fabtotal_requirement,
              consumption: rec.fabconsumption,
              wastage: rec.fabwastage,
              uom: rec.fabuom,
              remarks: rec.fab_remarks,
              colour: rec.garmentcolour,
              fabcolour: rec.fabColour,
              fabInfoId: rec.fabricInfoId,
            });
          }
        }
        const infoData: SampleRequestInfoModel[] = Array.from(MapData.values());

        return new CommonResponseModel(true, 1, "Data retrieved", infoData);
      } else {
        return new CommonResponseModel(false, 0, "No data found");
      }
    } catch (err) {
      throw err;
    }
  }

  async getUsageWhtsAppMsgs(): Promise<CommonResponseModel> {
    try {
      let date = moment().subtract(1, "days").format("YYYY-MM-DD");
      const manager = this.dataSource;
      const sampleOrders = `SELECT COUNT(DISTINCT sample_request_id)AS COUNT FROM sample_request_size_info WHERE DATE(created_at) = '${date}'`;
      const indents = `SELECT COUNT(request_no) AS COUNT FROM indent WHERE DATE(created_at) = '${date}'`;
      const pos = `SELECT COUNT(po_number) AS COUNT FROM purchase_order WHERE DATE(created_at) = '${date}'`;
      const grns = `SELECT COUNT(grn_number) AS COUNT FROM grn WHERE DATE(created_at) = '${date}'`;
      const stock = `SELECT COUNT(id) AS COUNT FROM stocks WHERE DATE(created_at) = '${date}'    `;
      const location = `SELECT COUNT(stock_log_id)AS COUNT FROM stock_log WHERE DATE(created_at) = '${date}'`;
      const material = `SELECT COUNT(material_allocation_id) AS COUNT FROM material_allocation WHERE DATE(updated_at) = '${date}' AND STATUS = 'MATERIAL ISSUED'`;
      const operations = `SELECT COUNT(operation_tracking_id) AS COUNT FROM operation_tracking WHERE DATE(created_at) = '${date}'`;
      const sampleOrdersInfo = await manager.query(sampleOrders);
      const indentsInfo = await manager.query(indents);
      const posInfo = await manager.query(pos);
      const grnsInfo = await manager.query(grns);
      const stockInfo = await manager.query(stock);
      const operationsInfo = await manager.query(operations);
      const materialInfo = await manager.query(material);
      const locationInfo = await manager.query(location);

      const datetime = moment().subtract(1, "days").format("MMMM Do, YYYY");

      // for (const ic of data) {
      //     let msgContent = '\\n' + ic.lifecycle_status + ' : ' + ic.COUNT
      //     vehiclelifecycle += msgContent;
      //     //   const status = ic.lifecycle_status;
      //     //   const count = ic.COUNT;
      //     // console.log(ic.lifecycle_status, '{}')
      // }

      const parameters = [
        { type: "text", text: datetime + "\\n" },
        { type: "text", text: sampleOrdersInfo?.[0]?.COUNT + "\\n" },
        { type: "text", text: indentsInfo?.[0]?.COUNT + "\\n" },
        { type: "text", text: posInfo?.[0]?.COUNT + "\\n" },
        { type: "text", text: grnsInfo?.[0]?.COUNT + "\\n" },
        { type: "text", text: locationInfo?.[0]?.COUNT + "\\n" },
        { type: "text", text: stockInfo?.[0]?.COUNT + "\\n" },
        { type: "text", text: materialInfo?.[0]?.COUNT + "\\n" },
        { type: "text", text: operationsInfo?.[0]?.COUNT + "\\n" },
      ];
      // console.log(parameters, 'Parameter-----------')

      const contacts = WhatsAppInfo.contacts;
      let statusFlag = true;
      let whatsappres;
      for (const contact of contacts) {
        whatsappres = await new MessageParameters(
          contact,
          "sampling_usage",
          parameters,
          "en_us"
        );
        console.log(whatsappres);
        const messageStatus = await this.wpService.sendMessageThroughFbApi(
          whatsappres
        );
        console.log(messageStatus);
        if (!messageStatus.status) {
          statusFlag = false;
          break;
        } else {
          statusFlag = true;
        }
      }
      // if (data) {
      return new CommonResponseModel(
        true,
        1,
        "Data Retrived Successfully",
        whatsappres
      );

      //     } else {
      //     return new CommonResponseModel(false, 0, 'No Data Found..', undefined)
      // }
    } catch (err) {
      throw err;
    }
  }

  async getUsageWhtsAppMsg(): Promise<CommonResponseModel> {
    try {
      let date = moment().subtract(1, "days").format("YYYY-MM-DD");
      const datetime = moment().subtract(1, "days").format("MMMM Do, YYYY");

      const manager = this.dataSource;

      const buyers = `SELECT buyer_id AS buyerId,buyer_code AS buyerCode,buyer_name AS buyerName from buyers where is_active = true order by buyer_name ASC`;
      const buyersData = await manager.query(buyers);
      // console.log(buyersData);
      let msg: any = "";
      let msg1: any = "";
      let msg2: any = "";
      let msg3: any = "";
      let msg4: any = "";
      let msg5: any = "";
      let count = 0;
      for (const [key, buy] of buyersData.entries()) {
        // console.log(key)
        // console.log(buy)
        // console.log(count+"count")

        const sampleOrders = `SELECT COUNT(DISTINCT si.sample_request_id) AS COUNT FROM sample_request_size_info si left join sample_request sr on sr.sample_request_id = si.sample_request_id WHERE sr.buyer_id = '${buy.buyerId}' and DATE(si.created_at) = '${date}'`;
        const indents = `SELECT COUNT(request_no) AS COUNT FROM indent WHERE buyer_id = '${buy.buyerId}' and DATE(created_at) = '${date}'`;
        const pos = `SELECT COUNT(po_number) AS COUNT FROM purchase_order WHERE buyer_id = '${buy.buyerId}' and DATE(created_at) = '${date}'`;
        const grns = `SELECT COUNT(g.grn_number) AS COUNT FROM grn g left join purchase_order po on po.purchase_order_id = g.po_id WHERE po.buyer_id = '${buy.buyerId}' and DATE(g.created_at) = '${date}'`;
        const stock = `SELECT COUNT(id) AS COUNT FROM stocks WHERE buyer_id = '${buy.buyerId}' and DATE(created_at) = '${date}'    `;
        const location = `SELECT COUNT(stock_log_id)AS COUNT FROM stock_log WHERE buyer_id = '${buy.buyerId}' and DATE(created_at) = '${date}'`;
        const material = `SELECT COUNT(material_allocation_id) AS COUNT FROM material_allocation WHERE buyer_id = '${buy.buyerId}' and DATE(updated_at) = '${date}' AND STATUS = 'MATERIAL ISSUED'`;
        const operations = `SELECT COUNT(operation_tracking_id) AS COUNT FROM operation_tracking ot left join sample_request sr on sr.sample_request_id = ot.sample_req_id WHERE sr.buyer_id = '${buy.buyerId}' and DATE(ot.created_at) = '${date}'`;
        const sampleOrdersInfo = await manager.query(sampleOrders);
        const indentsInfo = await manager.query(indents);
        const posInfo = await manager.query(pos);
        const grnsInfo = await manager.query(grns);
        const stockInfo = await manager.query(stock);
        const operationsInfo = await manager.query(operations);
        const materialInfo = await manager.query(material);
        const locationInfo = await manager.query(location);

        let messageContent = `*${buy.buyerCode} - ${buy.buyerName}* \\n Sample Orders : ${sampleOrdersInfo?.[0]?.COUNT} \\n Indents : ${indentsInfo?.[0]?.COUNT} \\n Purchase Orders :${posInfo?.[0]?.COUNT} \\n GRN's :${grnsInfo?.[0]?.COUNT} \\n Locations Mapping : ${locationInfo?.[0]?.COUNT} \\n Stock :${stockInfo?.[0]?.COUNT} \\n Material Issues : ${materialInfo?.[0]?.COUNT} \\n Operation Reporting : ${operationsInfo?.[0]?.COUNT} \\n \\n`;
        // console.log(messageContent)
        if (count < 4) {
          msg = msg + messageContent;
        } else if (count < 8) {
          msg1 = msg1 + messageContent;
        } else if (count < 12) {
          msg2 = msg2 + messageContent;
        } else if (count < 16) {
          msg3 = msg3 + messageContent;
        } else if (count < 20) {
          msg4 = msg4 + messageContent;
        } else if (count < 24) {
          msg5 = msg5 + messageContent;
        }
        count += 1;
      }
      // console.log("msg" + msg);
      // console.log("msg1" + msg1);
      // console.log("msg2" + msg2);
      // console.log("msg3" + msg3);
      // console.log("msg4" + msg4);
      // console.log("msg5" + msg5);

      let params: any[] = [];

      if (msg != "") {
        const parameters = [
          { type: "text", text: datetime },
          { type: "text", text: msg },
        ];
        params.push(parameters);
      }

      if (msg1 != "") {
        const parameters1 = [
          { type: "text", text: datetime },
          { type: "text", text: msg1 },
        ];
        params.push(parameters1);
      }

      if (msg2 != "") {
        const parameters2 = [
          { type: "text", text: datetime },
          { type: "text", text: msg2 },
        ];
        params.push(parameters2);
      }

      if (msg3 != "") {
        const parameters3 = [
          { type: "text", text: datetime },
          { type: "text", text: msg3 },
        ];
        params.push(parameters3);
      }

      if (msg4 != "") {
        const parameters4 = [
          { type: "text", text: datetime },
          { type: "text", text: msg4 },
        ];
        params.push(parameters4);
      }

      if (msg5 != "") {
        const parameters5 = [
          { type: "text", text: datetime },
          { type: "text", text: msg5 },
        ];
        params.push(parameters5);
      }
      // console.log(params)
      const contacts = WhatsAppInfo.contacts;
      let statusFlag = true;
      let whatsappres;
      for (const contact of contacts) {
        for (const parametr of params) {
          console.log(parametr);
          whatsappres = await new MessageParameters(
            contact,
            "sampling_buyer_usage",
            parametr,
            "en_us"
          );
          // console.log(whatsappres)
          const messageStatus = await this.wpService.sendMessageThroughFbApi(
            whatsappres
          );
          console.log(messageStatus);
          if (!messageStatus.status) {
            statusFlag = false;
            break;
          } else {
            statusFlag = true;
          }
        }
      }
      // if (data) {
      return new CommonResponseModel(
        true,
        1,
        "Data Retrived Successfully",
        whatsappres
      );

      //     } else {
      //     return new CommonResponseModel(false, 0, 'No Data Found..', undefined)
      // }
    } catch (err) {
      throw err;
    }
  }
  async getProcessAgainstSampleOrder(
    req?: SampleOrderIdRequest
  ): Promise<CommonResponseModel> {
    try {
      const manager = this.dataSource;
      let query =
        "select opg.operation_group_name AS operationGroupName, opg.operation_group_code AS operationName, opg.operation_group_id AS operationGroupId, sp.sequence AS sequence from sample_request_process_info sp left join operation_groups opg on opg.operation_group_id = sp.operation where sample_request_id=" +
        req.sampleRequestId +
        " order by sp.sequence ASC";
      const queryResult = await manager.query(query);
      // console.log("**************queryResult*******************")
      // console.log(queryResult)
      if (queryResult.length > 0) {
        return new CommonResponseModel(
          true,
          1001,
          "Data retrived successfully. ",
          queryResult
        );
      } else {
        return new CommonResponseModel(false, 1010, "No data found. ", []);
      }
    } catch (err) {
      throw err;
    }
  }

  async getFabricPaths(req: SampleItemIdRequest): Promise<CommonResponseModel> {
    const data = await this.fabricRepo.find({
      where: { fabricInfoId: req.sampleItemId },
    });
    if (data.length === 0) {
      return new CommonResponseModel(false, 0, "data not found", []);
    }
    return new CommonResponseModel(true, 123, "", data);
  }

  async getTrimPaths(req: SampleItemIdRequest): Promise<CommonResponseModel> {
    const data = await this.sampletrimrepo.find({
      where: { trimInfoId: req.sampleItemId },
    });
    if (data.length === 0) {
      return new CommonResponseModel(false, 0, "data not found", []);
    }
    return new CommonResponseModel(true, 123, "", data);
  }

  async getAllActiveSampleOrders(): Promise<CommonResponseModel> {
    try {
      const manager = this.dataSource;
      let query =
        "select sr.sample_request_id AS sampleReqId,sr.request_no AS requestNo, sr.location_id AS location, s.style, ph.profit_control_head AS pch,b.buyer_name AS buyer,bd.brand_name AS brand, sr.status from sample_request sr left join style s on s.style_id = sr.style_id left join profit_control_head ph on ph.profit_control_head_id = sr.profit_control_head_id left join brands bd on bd.brand_id = sr.brand_id left join buyers b on b.buyer_id = sr.buyer_id where sampling_user IS NULL";
      const queryResult = await manager.query(query);
      // console.log("**************queryResult*******************")
      // console.log(queryResult)
      if (queryResult.length > 0) {
        return new CommonResponseModel(
          true,
          1001,
          "Data retrived successfully. ",
          queryResult
        );
      } else {
        return new CommonResponseModel(false, 1010, "No data found. ", []);
      }
    } catch (err) {
      throw err;
    }
  }

  async getAllActiveSampleOrderscompletedProduction(): Promise<CommonResponseModel> {
    try {
      const manager = this.dataSource;
      let query =
        "select sr.sample_request_id AS sampleReqId,sr.request_no AS requestNo, sr.location_id AS location, s.style, ph.profit_control_head AS pch,b.buyer_name AS buyer,bd.brand_name AS brand, sr.status from sample_request sr left join style s on s.style_id = sr.style_id left join profit_control_head ph on ph.profit_control_head_id = sr.profit_control_head_id left join brands bd on bd.brand_id = sr.brand_id left join buyers b on b.buyer_id = sr.buyer_id";
      const queryResult = await manager.query(query);
      // console.log("**************queryResult*******************")
      // console.log(queryResult)
      if (queryResult.length > 0) {
        return new CommonResponseModel(
          true,
          1001,
          "Data retrived successfully. ",
          queryResult
        );
      } else {
        return new CommonResponseModel(false, 1010, "No data found. ", []);
      }
    } catch (err) {
      throw err;
    }
  }

  async updateSamplingperson(req: UserIdRequest): Promise<CommonResponseModel> {
    try {
      const updateSamplinguser = await this.sampleRepo.update(
        { SampleRequestId: req.sampleRequestId },
        { samplingUser: req.userId }
      );
      if (updateSamplinguser.affected > 0) {
        return new CommonResponseModel(
          true,
          1001,
          "Successfully updated Sampling User. "
        );
      } else {
        return new CommonResponseModel(
          false,
          1010,
          "something went wrong. ",
          []
        );
      }
    } catch (err) {
      throw err;
    }
  }

  async createSampleStorage(
    req: StorageLocationDto
  ): Promise<CommonResponseModel> {
    try {
      let storageEntity = new StorageLocation();
      storageEntity.sampleRequestId = req.sampleRequestId;
      storageEntity.location = req.location;
      storageEntity.quantity = req.quantity;
      const save = await this.sampleStorageLocationRepository.save(
        storageEntity
      );
      if (save.storageLocationId > 0) {
        return new CommonResponseModel(
          true,
          1001,
          "Successfully updated Sampling User. "
        );
      } else {
        return new CommonResponseModel(
          false,
          1010,
          "something went wrong. ",
          []
        );
      }
    } catch (err) {
      throw err;
    }
  }

  async getStorageLocationsAgainstOrder(
    req: sampleReqIdReq
  ): Promise<CommonResponseModel> {
    try {
      const manager = this.dataSource;
      const storageLocationsData =
        "Select l.location_name AS locationName, quantity from sample_storage_location left join locations_ l on l.location_id = location where sample_request_id = " +
        req.sampleReqId;
      const queryResult = await manager.query(storageLocationsData);

      if (queryResult.length > 0) {
        return new CommonResponseModel(
          true,
          1001,
          "Successfully retrived locations. ",
          queryResult
        );
      } else {
        return new CommonResponseModel(
          false,
          1010,
          "something went wrong. ",
          []
        );
      }
    } catch (err) {
      throw err;
    }
  }

  async updateSamNum(req: SamUpdateReq): Promise<CommonResponseModel> {
    try {
      const update = await this.sampleRepo.update(
        { SampleRequestId: req.sampleReqId },
        { samValue: req.samVal }
      );
      if (update.affected) {
        const query = ` SELECT sr.request_no as requestNo from sample_request sr
          where sr.sample_request_id =${req.sampleReqId}`;
        const response = await this.dataSource.query(query);
        if (response.length > 0) {
          try {
            return new CommonResponseModel(true, 0, "success", []);
          } catch (err) {}
        }
        return new CommonResponseModel(true, 1, "Sam Value Update Sucessfully");
      } else {
        return new CommonResponseModel(false, 0, "Something Went Wrong");
      }
    } catch (err) {
      throw err;
    }
  }
  async updatebudgetEffciency(req: SamUpdateReq): Promise<CommonResponseModel> {
    try {
      const update = await this.sampleRepo.update(
        { SampleRequestId: req.sampleReqId },
        {
          budgetEfficiency: req.budgetEfficiency,
          actualEfficiency: req.actualEfficiency,
        }
      );
      if (update.affected) {
        return new CommonResponseModel(
          true,
          1,
          "Budget Efficiency Updated Sucessfully"
        );
      } else {
        return new CommonResponseModel(false, 0, "Something Went Wrong");
      }
    } catch (err) {
      throw err;
    }
  }

  async getSampleReportData(req: Unitreqq): Promise<CommonResponseModel> {
    try {
      let data: any[] = [];
      const manager = this.dataSource;
      const storageLocationsData =
        "Select sr.category,sr.sample_request_id AS sampleReqId,sr.request_no AS reqNo,sr.sam_value AS samVal, sr.budget_efficiency AS budgetEff, sr.actual_efficiency AS actualEff, p.product ,pl.plant_Name as plantName, st.style from sample_request sr left join product p on p.product_id= sr.product left join style st on st.style_id= sr.style_id left join plants pl on pl.plant_id=sr.plant_id";
      const queryResult = await manager.query(storageLocationsData);
      if (queryResult.length > 0) {
        let operationData: any[] = [];
        for (const req of queryResult) {
          let operations =
            "Select ot.sample_req_id AS sampleReq,sr.category,sr.sample_request_id AS sampleReqId,sr.request_no AS reqNo,sr.sam_value AS samVal, sr.budget_efficiency AS budgetEff, sr.actual_efficiency AS actualEff, p.product , st.style, ot.operation,in_time AS inTime,out_time AS outTime, ed.first_name AS employee, edd.first_name AS supervisor,pl.plant_Name as plantName from operation_tracking ot left join employee_details ed on ed.employee_id = ot.reporter left join employee_details edd on edd.employee_id = ot.supervisor left join sample_request sr on sr.sample_request_id = ot.sample_req_id left join product p on p.product_id= sr.product left join style st on st.style_id= sr.style_id left join plants pl on pl.plant_id=sr.plant_id where ot.sample_req_id = " +
            req.sampleReqId;
          if (req.plantName) {
            operations += ` AND pl.plant_Name = '${req.plantName}'`;
          }

          const operationResult = await manager.query(operations);
          if (operationResult.length > 0) {
            for (const reqq of operationResult) {
              operationData.push(reqq);
            }
          } else {
            operationData.push(req);
          }
          // console.log(operationResult);
          // req["operationData"] = operationResult;
          // data.push(req);
        }
        return new CommonResponseModel(
          true,
          1001,
          "Successfully retrived locations. ",
          operationData
        );
      } else {
        return new CommonResponseModel(
          false,
          1010,
          "something went wrong. ",
          []
        );
      }
    } catch (err) {
      throw err;
    }
  }
  async getUnit(): Promise<CommonResponseModel> {
    try {
      const unitQuery = `
              SELECT pl.plant_Name as plantName 
              FROM sample_request sr 
             
              LEFT JOIN plants pl ON pl.plant_id = sr.plant_id 
              WHERE pl.plant_Name IS NOT NULL
              GROUP BY pl.plant_Name
          `;

      const result = await this.dataSource.query(unitQuery);

      if (result.length > 0) {
        return new CommonResponseModel(true, 1, "Data retrieved", result);
      } else {
        return new CommonResponseModel(false, 0, "No data found");
      }
    } catch (err) {
      return new CommonResponseModel(false, 0, "Failed to retrieve data");
    }
  }
  async getMaterialAllocateDataM3Fabric(
    req: SampleRequestId
  ): Promise<CommonResponseModel> {
    // console.log(req,'iam in service');

    try {
      const manager = this.dataSource;
      let query = `SELECT sr.location_id,m.item_type AS item,sr.sample_request_id AS sampleReqId,mai.quantity,mai.allocate_quantity AS allocateQty ,
        g. grn_number AS grnNumber, DATE(g.grn_date) AS grnDate,
        rp.rack_position_name AS location,mi.item_code AS fabricCode,m.sample_item_id as sampleItemId,  m.material_allocation_id as materialAllocationId
        FROM sample_request sr
        LEFT JOIN material_allocation m ON m.sample_order_id=sr.sample_request_id
        LEFT JOIN material_allocation_items mai ON mai.material_allocation_id=m.material_allocation_id
        LEFT JOIN grn_items gi ON gi.sample_req_id=sr.sample_request_id
        LEFT JOIN grn g ON g.grn_id=gi.grn_id
        LEFT JOIN stocks s ON s.id=mai.stock_id
        LEFT JOIN rack_position rp ON rp.position_id = s.location_id
        LEFT JOIN sample_request_fabric_info srf ON srf.sample_request_id = sr.sample_request_id
        LEFT JOIN sample_request_trim_info srt ON srt.sample_request_id = sr.sample_request_id
        LEFT JOIN m3_items mi ON mi.m3_items_Id = srf.fabric_code
       where  m.sample_item_id = '${req?.sampleRequestId}' AND m.item_type ='FABRIC'
       GROUP BY m.sample_item_id`;
      const queryResult = await manager.query(query);
      if (queryResult.length > 0) {
        return new CommonResponseModel(
          true,
          1001,
          "Data retrived successfully. ",
          queryResult
        );
      } else {
        return new CommonResponseModel(false, 1010, "No data found. ", []);
      }
    } catch (err) {
      throw err;
    }
  }

  async getMaterialAllocateDataM3Trim(
    req: TrimCodereqts
  ): Promise<CommonResponseModel> {
    try {
      // console.log(req, "I am in service");

      const manager = this.dataSource;
      let query = `
        SELECT 
          sr.location_id, 
          m.item_type AS item, 
          sr.sample_request_id AS sampleReqId, 
          mai.quantity, 
          mai.allocate_quantity AS allocateQty,
          g.grn_number AS grnNumber, 
          DATE(g.grn_date) AS grnDate,
          rp.rack_position_name AS location, 
          mt.description AS trimCode,
          m.sample_item_id as sampleItemId,
          m.material_allocation_id as materialAllocationId
        FROM 
          sample_request sr
        LEFT JOIN 
          material_allocation m ON m.sample_order_id = sr.sample_request_id
        LEFT JOIN 
          material_allocation_items mai ON mai.material_allocation_id = m.material_allocation_id
        LEFT JOIN 
          grn_items gi ON gi.sample_req_id = sr.sample_request_id
        LEFT JOIN 
          grn g ON g.grn_id = gi.grn_id
        LEFT JOIN 
          stocks s ON s.id = mai.stock_id
        LEFT JOIN 
          rack_position rp ON rp.position_id = s.location_id
        LEFT JOIN 
          sample_request_fabric_info srf ON srf.sample_request_id = sr.sample_request_id
        LEFT JOIN 
          sample_request_trim_info srt ON srt.sample_request_id = sr.sample_request_id
        LEFT JOIN 
          m3_trims mt ON mt.m3_trim_Id = srt.trim_code
        WHERE 
           m.sample_item_id = '${req?.sampleRequestId}' AND m.item_type ='SEWING_TRIM'
           GROUP BY m.sample_item_id`;

      const queryResult = await manager.query(query);

      if (queryResult.length > 0) {
        return new CommonResponseModel(
          true,
          1001,
          "Data retrieved successfully.",
          queryResult
        );
      } else {
        return new CommonResponseModel(false, 1010, "No data found.", []);
      }
    } catch (err) {
      console.error("Error in getMaterialAllocateDataM3Trim:", err);
      throw err;
    }
  }

  async getSampleOrderDetailsById(
    req: SampleIdRequest
  ): Promise<CommonResponseModel> {
    try {
      if (req.sampleRequestId != null) {
        let data = await this.sampleRepo.findOne({
          relations: [
            "sampleReqSizeInfo",
            "sampleReqFabricInfo",
            "sampleTrimInfo",
            "sampleProcessInfo",
            "style",
          ],
          where: { SampleRequestId: req.sampleRequestId },
        });
        if (data.SampleRequestId > 0) {
          return new CommonResponseModel(
            true,
            1,
            "Data retrived successfully. ",
            data
          );
        } else {
          return new CommonResponseModel(false, 0, "No data found. ", data);
        }
      } else {
        return new CommonResponseModel(false, 0, "No data found. ");
      }
    } catch (err) {
      console.error("Error in getMaterialAllocateDataM3Trim:", err);
      throw err;
    }
  }

  async updatePriority(req: SampleIdRequest): Promise<CommonResponseModel> {
    try {
      if (req.sampleRequestId != null) {
        let data = await this.sampleRepo.update(
          { SampleRequestId: req.sampleRequestId },
          { priority: req.priority }
        );
        if (data.affected > 0) {
          return new CommonResponseModel(
            true,
            1,
            "Priority updated successfully. ",
            data
          );
        } else {
          return new CommonResponseModel(false, 0, "No data found. ", data);
        }
      } else {
        return new CommonResponseModel(false, 0, "No data found. ");
      }
    } catch (err) {
      throw err;
    }
  }

  // async rejectPattern(req: RejectPattern): Promise<CommonResponseModel> {
  //   const manager = new GenericTransactionManager(this.dataSource);
  //   try {
  //     // console.log(req, "I am in service");
  //     await manager.startTransaction();
  //     let saveFlag = new Set<Boolean>();
  //     // console.log(req, "req in service");
      
  //     if (req.status === LifeCycleStatusEnum.OPEN) {
  //       // console.log('1111111111111111111');
        
  //       const sampleRequest = await this.sampleRepo.findOne({
  //         where: { SampleRequestId: req.sampleReqId },
  //       });
      
  //       if (sampleRequest) {
  //         const updateResult = await this.sampleRepo.update(
  //           { SampleRequestId: req.sampleReqId },
  //           { lifeCycleStatus: LifeCycleStatusEnum.REJECTED }
  //         );
  //         if (updateResult.affected > 0) {
  //           saveFlag.add(true);
  //         } else {
  //           saveFlag.add(false);
  //           return new CommonResponseModel(false, 0, "Failed to update sample request status to REJECTED");
  //         }
  //       }
  //     }
  //     const findSampleOrderId = await this.matAllRepo.findOne({where :{sampleOrderId : req.sampleReqId} })
  //     if (findSampleOrderId && req.status === LifeCycleStatusEnum.OPEN && findSampleOrderId.materialAllocationId) {
  //       // console.log('2222222222');
  //       const findStockId = await this.matAllitemRepo.findOne({
  //         where: {
  //           materialAllocationItemInfo: { materialAllocationId: findSampleOrderId.materialAllocationId }
  //         }
  //        })
  //       const findStockData = await this.stockrepo.findOne({where :{id : findStockId.stockId} })
  //       // console.log(findStockData, "findStockData");
  //       // console.log(findSampleOrderId, "findSampleOrderId");  
  //       // console.log(findStockId, "findStockId");
  //       // console.log(findStockId, "matAllocItemmmmmmmmmmmmmmmmmm");
  //       const newAllocQty = Number(findStockId?.allocateQuantity) - Number(findStockData?.allocateQuanty);
  //       // console.log(newAllocQty, "newAllocQty");
  //       const stockreverse = await this.stockrepo.update(
  //         { id: findStockId.stockId },
  //         { allocateQuanty: Number(newAllocQty) }
  //       );
  //       // console.log(stockreverse, "stockreverseeeeeeeeee");
  //       if (stockreverse.affected > 0) {
  //         saveFlag.add(true);
  //       } else {
  //         saveFlag.add(false);
  //         return new CommonResponseModel(false,0,"Something went wrong in stock allocation");
  //       }
  //       const status = await this.sampleRepo.update({ SampleRequestId: req.sampleReqId },{ lifeCycleStatus: LifeCycleStatusEnum.REJECTED });
  //       if (status.affected > 0) {
  //         saveFlag.add(true);
  //       } else {
  //         saveFlag.add(false);
  //         return new CommonResponseModel(false,0,"Something went wrong updating sample request");
  //       }
  //     }else{
  //       // console.log('3333333333');

  //     const sampleTrim = await this.dataSource.query(`
  //     SELECT st.trim_info_id FROM sample_request_trim_info st WHERE sample_request_id ='${req.sampleReqId}'`);
  //     // console.log(sampleTrim, "sampleTrimItems");
  //     const sampleTrims = sampleTrim.map((item: any) => item.trim_info_id).join(",");
  //     const sampleFabric = await this.dataSource.query(`SELECT sf.fabric_info_id FROM sample_request_fabric_info sf WHERE sample_request_id ='${req.sampleReqId}'`);
  //     const sampleFabrics = sampleFabric.map((item: any) => item.fabric_info_id).join(",");
  //     console.log(sampleFabric, sampleFabric.join(","), "sampleFabricItems");
  //     const poItemFab = await this.dataSource.query(`SELECT  DISTINCT( poi.purchase_order_id) FROM  purchae_order_items poi LEFT JOIN purchase_order po ON po.purchase_order_id = poi.purchase_order_id
  //     WHERE  sample_item_id IN(${sampleFabrics}) AND item_type ='FABRIC'  AND po.po_against='Sample Order'`);
  //     // console.log(poItemFab, "poItemFabbbbbbbbbb");

  //     const poItemtrims = await this.dataSource.query(`SELECT  DISTINCT( poi.purchase_order_id) FROM  purchae_order_items poi
  //     LEFT JOIN purchase_order po ON po.purchase_order_id = poi.purchase_order_id
  //     WHERE  sample_item_id IN(${sampleTrims}) AND item_type !='FABRIC' AND po.po_against='Sample Order'`);
  //     // console.log('oooooooooooooooooooooooo');

  //     const grns = await this.dataSource.query(`SELECT  g.grn_id, g.location_mapped_status,gi.po_id,gi.grn_item_id FROM grn_items gi LEFT JOIN grn g  ON g.grn_id= gi.grn_id WHERE gi.sample_req_id IN ('${req.sampleReqId}')`);
  //     const grn = grns.map((item: any) => item.grn_id).join(",");
  //     const grnPos = grns.map((item: any) => item.po_id);
  //     const grnitems = grns.map((item: any) => item.grn_item_id).join(",");
  //     // console.log(grn, "kkkkkkkkkkkkkkk");
  //     // console.log(grns, "grnIddddddddddd");
  //     // console.log(grnitems, "grnItemIddddddddddd"); 
  //     const poIds = [
  //       ...poItemFab.map((item) => item.purchase_order_id),
  //       ...poItemtrims.map((item) => item.purchase_order_id),
  //       ...grnPos.map((item) => item.po_id),];
  //     // for (const poId of poIds) {

  //     // console.log(poIds, "poidsd");
  //     if (grns.length > 0 && req.status !== LifeCycleStatusEnum.PO_RAISED) {
  //       saveFlag.add(true);
  //       for (const val of grns) {
  //         // console.log(val.location_mapped_status, "valId");

  //         if (val.location_mapped_status == LocationMappedEnum.COMPLETED) {
  //           // console.log(val.grn_id, "grnId");

  //           const grnUpdateResult = await this.grnRepo.update(
  //             {grnId: val.grn_id,
  //               // locationMapStatus: LocationMappedEnum.COMPLETED,
  //             },
  //             { status: PurchaseOrderStatus.CLOSED }
  //           );
  //           // if (grnUpdateResult.affected > 0) {
  //           //   saveFlag.add(true);
  //           // } else {
  //           //   saveFlag.add(false);
  //           //   return new CommonResponseModel(false, 0, "Something went wrong in updating grn");
  //           // }
  //           // console.log(grnUpdateResult, "grnUpdateResult");

  //           if (grnUpdateResult.affected === 0) {
  //             saveFlag.add(false);
  //             // console.warn("GRN update failed. ID:", val.grn_id);
  //             return new CommonResponseModel(
  //               false,
  //               0,
  //               "Something went wrong in updating grn"
  //             );
  //           } else {
  //             // if (val.status !== LocationMappedEnum.OPEN) {
  //             const stock = await this.stockrepo.findOne({
  //               where: { grnItemId: val.grn_item_id },
  //             });
  //             // const stockIds = stock.map((item: any) => item.stock_id); // keep as array
  //             // const matAllocItem = await this.matAllitemRepo.find({ where: { stockId: In(stockIds) } });
  //             // console.log(stock, "llllllllllllllllllllll");

  //             // for(const val of stock) {
  //             const matAllocItem = await this.matAllitemRepo.findOne({
  //               where: { stockId: stock?.id },
  //             });
  //             if (matAllocItem) {
  //               // console.log(matAllocItem, "5555555555555");

  //               const newAllocQty = Number(matAllocItem?.allocateQuantity) - Number(stock?.allocateQuanty);
  //               // console.log(newAllocQty, "newAllocQty");

  //               const stockreverse = await this.stockrepo.update(
  //                 { grnItemId: val.grn_item_id },
  //                 { allocateQuanty: Number(newAllocQty) }
  //               );
  //               // console.log(stockreverse, "opppppppopppppppppppopopopop");
  //               if (stockreverse.affected > 0) {
  //                 saveFlag.add(true);
  //               } else {
  //                 saveFlag.add(false);

  //                 return new CommonResponseModel(false,0,"Something went wrong in stock allocation");
  //               }
  //             }
  //           }
  //         } else {
  //           saveFlag.add(false);
  //           return new CommonResponseModel(
  //             false,
  //             0,
  //             "Rejection is not allowed for not allocated materials"
  //           );
  //         }
  //       }
  //       const status = await this.sampleRepo.update({ SampleRequestId: req.sampleReqId },{ lifeCycleStatus: LifeCycleStatusEnum.REJECTED });
  //       if (status.affected > 0) {
  //         saveFlag.add(true);
  //       } else {
  //         saveFlag.add(false);
  //         return new CommonResponseModel(false,0,"Something went wrong updating sample request");
  //       }
  //     } else {
  //       // console.log(grn.length, "grn length");
  //       const poUpdateResult = await this.poRepo.update({ purchaseOrderId: In(poIds) },{ status: PurchaseOrderStatus.CLOSED });
  //       if (poUpdateResult.affected > 0) {
  //         saveFlag.add(true);
  //       } else {
  //         saveFlag.add(false);
  //         return new CommonResponseModel(
  //           false,
  //           0,
  //           "Something went wrong in updating po"
  //         );
  //       }

  //       const status = await this.sampleRepo.update({ SampleRequestId: req.sampleReqId },{ lifeCycleStatus: LifeCycleStatusEnum.REJECTED });
  //       if (status.affected > 0) {
  //     saveFlag.add(true);
  //       } else {
  //         saveFlag.add(false);
  //         return new CommonResponseModel(
  //           false,
  //           0,
  //           "Something went wrong updating sample request"
  //         );
  //       }
  //     }
  //     }
  //     if (!saveFlag.has(false)) {
  //       await manager.completeTransaction();
  //       return new CommonResponseModel(true, 1, "Saved successfully");
  //     } else {
  //       await manager.releaseTransaction();
  //       return new CommonResponseModel(false, 0, "Something went wrong ");
  //     }
  //   } catch (err) {
  //     console.error("Error in rejectPattern:", err);
  //     throw new Error("Internal server error");
  //   }
  // }

  async rejectPattern(req: RejectPattern): Promise<CommonResponseModel> {
    const manager = new GenericTransactionManager(this.dataSource);
    try {
      await manager.startTransaction();
      let soUpdate = true
      let stockUpdateFlag = true;
      let poUpdateFlag = true;

      let checkPendingAllocations = await this.grnItemRepo.find({where:{status: Not(LocationMappedEnum.COMPLETED)}});
      if(checkPendingAllocations.length > 0){
          await manager.releaseTransaction();
          return new CommonResponseModel(false,0,"Please allocation location for received grn. ",);
      }
      else{
       

        let checkAllocatedStock = await this.matAllRepo.find({where:{sampleOrderId:req.sampleReqId}});
        if(checkAllocatedStock.length > 0){
          for(let rs of checkAllocatedStock){
            let getItemDetails = await this.matAllitemRepo.find({relations:["materialAllocationItemInfo"], where:{materialAllocationItemInfo:{materialAllocationId:rs.materialAllocationId}}});
            for(let i of getItemDetails){
              let reverseStock = await this.stockrepo.update({id:i.stockId},{allocateQuanty: () => `allocatd_quantity -  ${i.quantity}`});
              if(!reverseStock.affected){
                stockUpdateFlag = false
              }
            }
          }
        }
        let getFabIds = await this.fabricRepo.find({select:["fabricInfoId"],relations:["samplerReqFabricEntity"],where:{samplerReqFabricEntity:{SampleRequestId:req.sampleReqId}}});
        let gettrimIds = await this.sampletrimrepo.find({select:["trimInfoId"],relations:["sampleDevReqInfo"],where:{sampleDevReqInfo:{SampleRequestId:req.sampleReqId}}});
        let checkFabPoexist = await this.poItemRepo.find({relations:["purchaseOrderEntity"],where:{sampleItemId:In(getFabIds),poitemStatus:Not(PoItemEnum.RECEIVED)}});
        let checkTrimPoexist = await this.poItemRepo.find({where:{sampleItemId:In(gettrimIds),poitemStatus:Not(PoItemEnum.RECEIVED)}});
        if(checkFabPoexist?.length > 0 || checkTrimPoexist?.length > 0){
          let poId = 0
          if(checkFabPoexist?.length > 0){
            poId =checkFabPoexist[0]?.purchaseOrderEntity?.purchaseOrderId;
          }
          else if(checkTrimPoexist?.length > 0){
            poId =checkTrimPoexist[0]?.purchaseOrderEntity?.purchaseOrderId;
          }

          let updatePo = await this.poRepo.update({purchaseOrderId:poId},{status:PurchaseOrderStatus.CLOSED})
          if(!updatePo.affected){
            poUpdateFlag = false;
          }
        }
        let updateSO = await this.sampleRepo.update({SampleRequestId:req.sampleReqId},{lifeCycleStatus:LifeCycleStatusEnum.REJECTED});
        if(!updateSO.affected){
          soUpdate = false;
        }
        
      }
      if(!soUpdate || !stockUpdateFlag || !poUpdateFlag){
        await manager.releaseTransaction();
        return new CommonResponseModel(false,0,"Something went wrong. ",);
      }
      else{
        await manager.completeTransaction()
        return new CommonResponseModel(true,1,"Sample Order reversed successfully. ",);
      }
    }catch (err) {
      throw err;
    }
  }
}
